/*eslint eqeqeq: [ 0 ]*/
import React, { Component } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
// import { Link } from 'react-router-dom';
import { withStyles } from "@material-ui/core/styles";

// import 'typeface-roboto';
import Checkbox from "@material-ui/core/Checkbox";
// import FormGroup from '@material-ui/core/FormGroup';
// import MaskedInput from 'react-text-mask';
// import NumberFormat from 'react-number-format';
import Edit from "@material-ui/icons/Edit";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import classnames from "classnames";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Select from "@material-ui/core/Select";
import Step from "@material-ui/core/Step";
import StepContent from "@material-ui/core/StepContent";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import Table from "@material-ui/core/Table";

import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import { Consumer } from "./EWPLContext";
import PLAgreementText from "./PLAgreement";
import styles from "../ewccstyle";
import {
  StepButtons,
  TinCustom,
  SSSCustom,
  HomeAreaCode,
  HomeTelCustom2,
  HomeTelCustom1,
  MobileCustom,
  CurrencyCustom,
  DateCustom,
  ReviewTableRow,
  ZipCustom,
  SpecialSelect,
  maxDate,
  minDate,
} from "../CommonComponents";
import { Redirect } from "react-router";
import { ewbConfig } from "../../../config";
import { sexList } from "../LoansSpecialList";
import { THIS_FIELD_IS_REQUIRED } from "utils/constants";

const civilStatusList = [
  { value: "1", label: "Single" },
  { value: "2", label: "Married" },
  { value: "3", label: "Legally Separated" },
  { value: "4", label: "Widow(er)" },
];

const educationList = [
  { value: "1", label: "High School" },
  { value: "2", label: "College" },
  { value: "3", label: "Some College" },
  { value: "4", label: "Post Graduate" },
];

const citizenshipList = [
  { value: "1", label: "Filipino" },
  { value: "2", label: "Others" },
];

const homeOwnershipList = [
  { value: "1", label: "Owned, Mortaged" },
  { value: "2", label: "Owned, Not Mortaged" },
  { value: "3", label: "Living w/ Parents/Relatives" },
  { value: "4", label: "Company Provided" },
  { value: "0", label: "Rented " },
  { value: "0", label: "Monthly Rental fee" },
  { value: "4", label: "Others" },
];

const employmentList = [
  { value: "1", label: "Self-employed" },
  { value: "2", label: "Private" },
  { value: "3", label: "Government" },
  { value: "4", label: "Retired" },
  { value: "5", label: "Others" },
];

const positionList = [
  { value: "1", label: "Clerk" },
  { value: "2", label: "Officer-Junior/Supervisor" },
  { value: "3", label: "Officer-Senior" },
  { value: "4", label: "Executive" },
  { value: "5", label: "Non-Officer" },
  { value: "6", label: "OFW" },
  { value: "7", label: "Religious" },
  { value: "8", label: "Retired" },
  { value: "9", label: "Production Worker" },
  { value: "10", label: "Self-employed/Proprietor" },
  { value: "11", label: "Others" },
];

const natureOfPresentBusinessList = [
  { value: "1", label: "Agricultural/Mining" },
  { value: "2", label: "Banking" },
  { value: "3", label: "Business/Commercial Services" },
  { value: "4", label: "Community/Social/Personal" },
  { value: "5", label: "Construction" },
  { value: "6", label: "Financing" },
  { value: "7", label: "Insurance" },
  { value: "8", label: "Manufacturing" },
  { value: "9", label: "Real Estate" },
  { value: "10", label: "Transportation/Communication" },
  { value: "11", label: "Utilities" },
  { value: "12", label: "Wholesale/Retail" },
  { value: "13", label: "Others" },
];

const sourceOfFundsList = [
  { value: "1", label: "Salary/Benefits" },
  { value: "2", label: "Allowances" },
  { value: "3", label: "Business Income" },
  { value: "4", label: "Remittances" },
  { value: "5", label: "Retirement/Separation" },
  { value: "6", label: "Investment" },
  { value: "7", label: "Others" },
];

const occupationList = [
  { value: "1", label: "Administrator/Executive" },
  { value: "2", label: "Professional/Technical" },
  { value: "3", label: "Service Worker" },
  { value: "4", label: "Agricultural" },
  { value: "5", label: "Clerical" },
  { value: "6", label: "Self-employed" },
  { value: "7", label: "Armed Forces/Military" },
  { value: "8", label: "Production/Transport" },
  { value: "9", label: "Sales Worker" },
  { value: "10", label: "Others" },
];

const loanPurposeList = [
  { value: "1", label: "Home Improvement/Lot Purchase" },
  { value: "2", label: "Car Purchase/Repair" },
  { value: "3", label: "Appliance/Furniture Purchase" },
  { value: "4", label: "Travel/Vacation" },
  { value: "5", label: "Medical Expenses" },
  { value: "6", label: "Tuition Fee/School Expenses" },
  { value: "7", label: "Credit Card Payment" },
  { value: "8", label: "Bills Payment" },
  { value: "9", label: "Others" },
];

const myPreferredPaymentTenorList = [
  { value: "2", label: "12 months" },
  { value: "3", label: "18 months" },
  { value: "4", label: "24 months" },
  { value: "5", label: "36 months" },
  { value: "6", label: "48 months" },
  { value: "7", label: "60 months" },
];

const MyPersonalInformation = withStyles(styles)(function (props) {
  const { activeStep, handleBack, maxStep, classes } = props;

  return (
    <Consumer>
      {(context) => (
        <Formik
          initialValues={{
            firstName: context.firstName,
            middleName: context.middleName,
            lastName: context.lastName,
            birthDate: context.birthDate,
            birthPlace: context.birthPlace,
            momFirstName: context.momFirstName,
            momMiddleName: context.momMiddleName,
            momLastName: context.momLastName,
            gender: context.gender,
            civilStatus: context.civilStatus,
            education: context.education,
            acrNo: context.acrNo,
            sssNo: context.sssNo,
            dependentsNo: context.dependentsNo,
            citizenship: context.citizenship,
            tinNo: context.tinNo,
            presentHomeAddr: context.presentHomeAddr,
            presentZipCode: context.presentZipCode,
            permanentHomeAddr: context.permanentHomeAddr,
            permanentZipCode: context.permanentZipCode,
            homeOwnership: context.homeOwnership,
            homeStayYrs: context.homeStayYrs,
            homeAreaCode: context.homeAreaCode,
            homePhone: context.homePhone,
            mobilePhone: context.mobilePhone,
            dayToCall: context.dayToCall,
            timeToCall: context.timeToCall,
            email: context.email,
            facebook: context.facebook,
            twitter: context.twitter,
            im: context.im,
            carsOwnedNo: context.carsOwnedNo,
            chkPermAddSameWithHomeAdd: context.chkPermAddSameWithHomeAdd,
          }}
          validationSchema={Yup.object().shape(
            {
              firstName: Yup.string()
                .min(2, "First name is too short")
                .max(20, "First name is too long")
                .required("First name is required"),
              middleName: Yup.string()
                .min(2, "Middle name is too short")
                .max(20, "Middle name is too long")
                .required("Middle name is required"),
              lastName: Yup.string()
                .min(2, "Last name is too short")
                .max(20, "Last name is too long")
                .required("Last name is required"),
              // birthDate: Yup.string().required("Birth Date is required"),
              birthDate: Yup.date()
                // .matches(/\d\d\d-\d\d\d-\d\d\d/, "Invalid Birth Date")
                .required("Birth Date is required"),
              birthPlace: Yup.string()
                .min(3, "Birth Place is too short")
                .max(20, "Birth Place is too long")
                .required("Birth Place is required"),
              momFirstName: Yup.string()
                .min(2, "First name is too short")
                .max(20, "First name is too long")
                .required("First name is required"),
              momMiddleName: Yup.string()
                .min(2, "Middle name is too short")
                .max(20, "Middle name is too long")
                .required("Middle name is required"),
              momLastName: Yup.string()
                .min(2, "Last name is too short")
                .max(20, "Last name is too long")
                .required("Last name is required"),
              gender: Yup.string().required("Please select a gender"),
              civilStatus: Yup.string().required(
                "Please select a civil status"
              ),
              education: Yup.string().required("Please select an education"),

              tinNo: Yup.string()
                .matches(/\d\d\d-\d\d\d-\d\d\d/, "Invalid TIN")
                .required("Tax Identification Number (TIN) is required"),
              dependentsNo: Yup.number()
                .positive("Invalid Entry")
                .integer("Invalid Entry")
                .min(0, "Invalid Entry")
                .max(50, "Invalid Entry")
                .required("Number of dependents is required"),
              citizenship: Yup.string().required("Please select a citizenship"),
              presentHomeAddr: Yup.string()
                .min(15, "Address is too short")
                .max(120, "Address is too long")
                .required("required"),
              presentZipCode: Yup.string()
                .matches(/\d\d\d\d/, "Zip code is required")
                .required("Zip code is required"),
              permanentHomeAddr: Yup.string()
                .min(15, "Address is too short")
                .max(120, "Address is too long"),
              // .required("required"),
              permanentZipCode: Yup.string().matches(
                /\d\d\d\d/,
                "Zip code is required"
              ),
              // .required("Zip code is required"),
              homeOwnership: Yup.string().required(
                "Please select a home ownership"
              ),
              sssNo: Yup.string()
                .matches(/\d\d-\d\d\d\d\d\d\d-\d/, "Invalid SSS number")
                .required("SSS/GSIS No. is required"),
              homeStayYrs: Yup.number()
                .positive("Invalid Entry")
                .integer("Invalid Entry")
                .min(0, "Invalid Entry")
                .max(50, "Invalid Entry")
                .required("Please input years of stay"),
              homePhone: Yup.string()
                .matches(/\d\d\d\d-\d\d\d\d/, "Invalid Number")
                .when("homeAreaCode", {
                  is: (homeAreaCode) => homeAreaCode != undefined,
                  then: Yup.string().required("Home Phone Number is required"),
                }),

              homeAreaCode: Yup.string()
                .matches(/\d\d/, "Invalid Area Code")
                .when("homePhone", {
                  is: (homePhone) => homePhone != undefined,
                  then: Yup.string().required("Area Code is required"),
                }),
              mobilePhone: Yup.string()
                .matches(
                  /\(\d\d\)\s\d\d\d-\d\d\d-\d\d\d\d/,
                  "Invalid Mobile Phone Number"
                )
                .required("Mobile Phone Number is required"),
              email: Yup.string()
                .email()
                .max(50, "Email is too long")
                .required("required"),
              facebook: Yup.string().max(100, "Invalid input"),
              twitter: Yup.string().max(100, "Invalid input"),
              im: Yup.string().max(100, "Invalid input"),
              carsOwnedNo: Yup.string().max(2, "Invalid input"),
            },
            [["homePhone", "homeAreaCode"]]
          )}
          onSubmit={(values, actions) => {
            context.updateState("firstName", values.firstName);
            context.updateState("middleName", values.middleName);
            context.updateState("lastName", values.lastName);
            context.updateState("birthDate", values.birthDate);
            context.updateState("birthPlace", values.birthPlace);
            context.updateState("momFirstName", values.momFirstName);
            context.updateState("momMiddleName", values.momMiddleName);
            context.updateState("momLastName", values.momLastName);
            context.updateState("gender", values.gender);
            context.updateState("civilStatus", values.civilStatus);
            context.updateState("education", values.education);
            context.updateState("acrNo", values.acrNo);
            context.updateState("sssNo", values.sssNo);
            context.updateState("dependentsNo", values.dependentsNo);
            context.updateState("citizenship", values.citizenship);
            context.updateState("tinNo", values.tinNo);
            context.updateState("presentHomeAddr", values.presentHomeAddr);
            context.updateState("presentZipCode", values.presentZipCode);
            context.updateState("permanentHomeAddr", values.permanentHomeAddr);
            context.updateState("permanentZipCode", values.permanentZipCode);
            context.updateState("homeOwnership", values.homeOwnership);
            context.updateState("homeStayYrs", values.homeStayYrs);
            context.updateState("homeAreaCode", values.homeAreaCode);
            context.updateState("homePhone", values.homePhone);
            context.updateState("mobilePhone", values.mobilePhone);
            context.updateState("dayToCall", values.dayToCall);
            context.updateState("timeToCall", values.timeToCall);
            context.updateState("email", values.email);
            context.updateState("facebook", values.facebook);
            context.updateState("twitter", values.twitter);
            context.updateState("im", values.im);
            context.updateState("carsOwnedNo", values.carsOwnedNo);
            context.updateState(
              "chkPermAddSameWithHomeAdd",
              values.chkPermAddSameWithHomeAdd
            );

            actions.setSubmitting(false);
            props.handleSubmit();
            // console.log(values.firstName)
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            /* and other goodies */
          }) => (
            <>
              <form noValidate autoComplete="off">
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="firstName"
                    label="First Name"
                    value={values.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.firstName && touched.firstName ? true : false}
                    helperText={touched.firstName ? errors.firstName : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="middleName"
                    label="Middle Name"
                    value={values.middleName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.middleName && touched.middleName ? true : false
                    }
                    helperText={touched.middleName ? errors.middleName : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="lastName"
                    label="Last Name"
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.lastName && touched.lastName ? true : false}
                    helperText={touched.lastName ? errors.lastName : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="birthDate"
                    label="BirthDate"
                    type="date"
                    placeholder="01/02/1980"
                    value={values.birthDate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: minDate,
                      max: maxDate,
                    }}
                    classes={{ root: classes.marginDense }}
                    error={errors.birthDate && touched.birthDate ? true : false}
                    helperText={touched.birthDate ? errors.birthDate : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="birthPlace"
                    label="Birth Place"
                    value={values.birthPlace}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.birthPlace && touched.birthPlace ? true : false
                    }
                    helperText={touched.birthPlace ? errors.birthPlace : ""}
                  />
                </FormControl>
                <br /> <br />
                <FormControl fullWidth margin="dense">
                  <FormLabel component="legend">
                    Mother's Full Maiden Name
                  </FormLabel>
                  <TextField
                    required
                    id="momFirstName"
                    label="Mother's First Name"
                    value={values.momFirstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.momFirstName && touched.momFirstName ? true : false
                    }
                    helperText={touched.momFirstName ? errors.momFirstName : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="momMiddleName"
                    label="Mother's Middle Name"
                    value={values.momMiddleName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.momMiddleName && touched.momMiddleName
                        ? true
                        : false
                    }
                    helperText={
                      touched.momMiddleName ? errors.momMiddleName : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="momLastName"
                    label="Mother's Last Name"
                    value={values.momLastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.momLastName && touched.momLastName ? true : false
                    }
                    helperText={touched.momLastName ? errors.momLastName : ""}
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.gender && touched.gender ? true : false}
                >
                  <InputLabel required htmlFor="gender">
                    Gender
                  </InputLabel>
                  <SpecialSelect
                    id="gender"
                    name="gender"
                    value={values.gender}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={sexList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.gender && touched.gender && <>{errors.gender}</>}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.civilStatus && touched.civilStatus ? true : false
                  }
                >
                  <InputLabel required htmlFor="civilStatus">
                    Civil Status
                  </InputLabel>
                  <SpecialSelect
                    id="civilStatus"
                    name="civilStatus"
                    value={values.civilStatus}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={civilStatusList}
                  />

                  <FormHelperText
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="h6"
                  >
                    <>
                      {errors.civilStatus && touched.civilStatus
                        ? errors.civilStatus
                        : 'If your Civil Status is "Married", fields on the spouse section with an asterisk are mandatory'}
                    </>
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="dependentsNo"
                    label="No. of Dependents"
                    value={values.dependentsNo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // onKeyDown={evt => evt.key === "e" && evt.preventDefault()}
                    type="number"
                    error={
                      errors.dependentsNo && touched.dependentsNo ? true : false
                    }
                    helperText={
                      touched.dependentsNo
                        ? errors.dependentsNo
                        : "If no dependent, kindly indicate 0"
                    }
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.education && touched.education ? true : false}
                >
                  <InputLabel required htmlFor="education">
                    Education
                  </InputLabel>
                  <SpecialSelect
                    id="education"
                    name="education"
                    value={values.education}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={educationList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.education && touched.education && (
                      <>{errors.education}</>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.citizenship && touched.citizenship ? true : false
                  }
                >
                  <InputLabel required htmlFor="citizenship">
                    Citizenship
                  </InputLabel>
                  <SpecialSelect
                    id="citizenship"
                    name="citizenship"
                    value={values.citizenship}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={citizenshipList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.citizenship && touched.citizenship && (
                      <>{errors.citizenship}</>
                    )}
                  </FormHelperText>
                </FormControl>
                {values.citizenship == 2 ? (
                  <FormControl fullWidth margin="dense">
                    <TextField
                      // onKeyDown={evt => evt.key === "e" && evt.preventDefault()}
                      type="number"
                      id="acrNo"
                      label="ACR No."
                      value={values.acrNo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.acrNo && touched.acrNo ? true : false}
                      helperText={touched.acrNo ? errors.acrNo : ""}
                    />
                  </FormControl>
                ) : (
                  ""
                )}
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.tinNo && touched.tinNo ? true : false}
                >
                  <InputLabel required htmlFor="tinNo">
                    Tax Identification Number (TIN)
                  </InputLabel>
                  <Input
                    id="tinNo"
                    value={values.tinNo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.tinNo && touched.tinNo ? true : false}
                    inputComponent={TinCustom}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.tinNo && touched.tinNo && <>{errors.tinNo}</>}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.sssNo && touched.sssNo ? true : false}
                >
                  <InputLabel required htmlFor="sssNo">
                    SSS/GSIS No.
                  </InputLabel>
                  <Input
                    id="sssNo"
                    value={values.sssNo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.sssNo && touched.sssNo ? true : false}
                    inputComponent={SSSCustom}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.sssNo && touched.sssNo && <>{errors.sssNo}</>}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="presentHomeAddr"
                    label="Present Home Address"
                    value={values.presentHomeAddr}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.presentHomeAddr && touched.presentHomeAddr
                        ? true
                        : false
                    }
                    helperText={
                      touched.presentHomeAddr ? errors.presentHomeAddr : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="presentZipCode"
                    label="Zip Code"
                    value={values.presentZipCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.presentZipCode && touched.presentZipCode
                        ? true
                        : false
                    }
                    helperText={
                      touched.presentZipCode ? errors.presentZipCode : ""
                    }
                    InputProps={{
                      inputComponent: ZipCustom,
                    }}
                  />
                </FormControl>
                {/* 
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="permanentHomeAddr"
                    label="Permanent Home Address"
                    value={values.permanentHomeAddr}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.permanentHomeAddr && touched.permanentHomeAddr
                        ? true
                        : false
                    }
                    helperText={
                      touched.permanentHomeAddr ? errors.permanentHomeAddr : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="permanentZipCode"
                    label="Zip Code"
                    value={values.permanentZipCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.permanentZipCode && touched.permanentZipCode
                        ? true
                        : false
                    }
                    helperText={
                      touched.permanentZipCode ? errors.permanentZipCode : ""
                    }
                    InputProps={{
                      inputComponent: ZipCustom
                    }}
                  />
                </FormControl> */}
                <FormControl fullWidth>
                  <FormControlLabel
                    control={
                      <Checkbox
                        // checked={values.chkPermAddSameWithHomeAdd}
                        onChange={handleChange}
                        value="true"
                        id="chkPermAddSameWithHomeAdd"
                        name="chkPermAddSameWithHomeAdd"
                      />
                    }
                    label="Please check if same as Present/Home Address"
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.radioError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.chkPermAddSameWithHomeAdd &&
                      touched.chkPermAddSameWithHomeAdd && (
                        <>{errors.chkPermAddSameWithHomeAdd}</>
                      )}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  {values.chkPermAddSameWithHomeAdd === true ? (
                    <TextField
                      id="permanentHomeAddr"
                      label="Permanent Address"
                      className={classes.textField}
                      value={
                        (values.permanentHomeAddr = values.presentHomeAddr)
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText="Limit input to 120 characters including spaces"
                      fullWidth
                    />
                  ) : (
                    <TextField
                      id="permanentHomeAddr"
                      label="Permanent Address"
                      className={classes.textField}
                      value={values.permanentHomeAddr}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText="Limit input to 120 characters including spaces"
                      fullWidth
                    />
                  )}
                </FormControl>
                <FormControl fullWidth margin="dense">
                  {values.chkPermAddSameWithHomeAdd === true ? (
                    <TextField
                      id="permanentZipCode"
                      label="Zip Code"
                      className={classes.textField}
                      value={(values.permanentZipCode = values.presentZipCode)}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      InputProps={{
                        inputComponent: ZipCustom,
                      }}
                      helperText={
                        errors.permanentZipCode && touched.permanentZipCode
                          ? errors.permanentZipCode
                          : ""
                      }
                      error={
                        errors.permanentZipCode && touched.permanentZipCode
                          ? true
                          : false
                      }
                    />
                  ) : (
                    <TextField
                      id="permanentZipCode"
                      label="Zip Code"
                      className={classes.textField}
                      value={values.permanentZipCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      InputProps={{
                        inputComponent: ZipCustom,
                      }}
                      helperText={
                        errors.permanentZipCode && touched.permanentZipCode
                          ? errors.permanentZipCode
                          : ""
                      }
                      error={
                        errors.permanentZipCode && touched.permanentZipCode
                          ? true
                          : false
                      }
                    />
                  )}
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.homeOwnership && touched.homeOwnership ? true : false
                  }
                >
                  <InputLabel required htmlFor="homeOwnership">
                    Home Ownership
                  </InputLabel>
                  <SpecialSelect
                    id="homeOwnership"
                    name="homeOwnership"
                    value={values.homeOwnership}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={homeOwnershipList}
                  />

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.homeOwnership && touched.homeOwnership && (
                      <>{errors.homeOwnership}</>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    type="number"
                    id="homeStayYrs"
                    label="Years of Stay"
                    value={values.homeStayYrs}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.homeStayYrs && touched.homeStayYrs ? true : false
                    }
                    helperText={touched.homeStayYrs ? errors.homeStayYrs : ""}
                  />
                </FormControl>
                <Grid container className={classes.homeNumber}>
                  <FormControl
                    // fullWidth
                    margin="dense"
                    error={errors.homeAreaCode ? true : false}
                  >
                    <InputLabel htmlFor="homeAreaCode">Area Code</InputLabel>
                    <Input
                      // type="number"
                      id="homeAreaCode"
                      value={values.homeAreaCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.homeAreaCode && touched.homeAreaCode
                          ? true
                          : false
                      }
                      inputComponent={HomeAreaCode}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.homeAreaCode ||
                        (touched.homeAreaCode && <>{errors.homeAreaCode}</>)}
                    </FormHelperText>
                  </FormControl>
                  <FormControl
                    // fullWidth
                    margin="dense"
                    error={errors.homePhone ? true : false}
                  >
                    <InputLabel htmlFor="homePhone">
                      Home Phone Number
                    </InputLabel>
                    <Input
                      // type="number"
                      id="homePhone"
                      value={values.homePhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.homePhone && touched.homePhone ? true : false
                      }
                      inputComponent={HomeTelCustom2}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.homePhone ||
                        (touched.homePhone && <>{errors.homePhone}</>)}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.mobilePhone && touched.mobilePhone ? true : false
                  }
                >
                  <InputLabel required htmlFor="mobilePhone">
                    Mobile Phone
                  </InputLabel>
                  <Input
                    id="mobilePhone"
                    value={values.mobilePhone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.mobilePhone && touched.mobilePhone ? true : false
                    }
                    inputComponent={MobileCustom}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.mobilePhone && touched.mobilePhone && (
                      <>{errors.mobilePhone}</>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.dayToCall && touched.dayToCall ? true : false}
                >
                  <InputLabel htmlFor="dayToCall">Best Day to Call</InputLabel>
                  <Select
                    native
                    autoWidth={true}
                    value={values.dayToCall}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{
                      name: "dayToCall",
                      id: "dayToCall",
                    }}
                  >
                    <option value="" />
                    <option value="Monday">Monday</option>
                    <option value="Tuesday">Tuesday</option>
                    <option value="Wednesday">Wednesday</option>
                    <option value="Thursday">Thursday</option>
                    <option value="Friday">Friday</option>
                  </Select>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.dayToCall && touched.dayToCall && (
                      <>{errors.dayToCall}</>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    type="time"
                    id="timeToCall"
                    // defaultValue="09:30"
                    label="Best Time To Call"
                    value={values.timeToCall}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.timeToCall && touched.timeToCall ? true : false
                    }
                    helperText={touched.timeToCall ? errors.timeToCall : ""}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      step: 300, // 5 min
                    }}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    type="email"
                    id="email"
                    label="Email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.email && touched.email ? true : false}
                    helperText={touched.email ? errors.email : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="facebook"
                    label="Facebook"
                    value={values.facebook}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.facebook && touched.facebook ? true : false}
                    helperText={touched.facebook ? errors.facebook : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="twitter"
                    label="Twitter"
                    value={values.twitter}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.twitter && touched.twitter ? true : false}
                    helperText={touched.twitter ? errors.twitter : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="im"
                    label="IM"
                    value={values.im}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.im && touched.im ? true : false}
                    helperText={touched.im ? errors.im : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    type="number"
                    id="carsOwnedNo"
                    label="No. of Cars Owned"
                    value={values.carsOwnedNo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.carsOwnedNo && touched.carsOwnedNo ? true : false
                    }
                    helperText={touched.carsOwnedNo ? errors.carsOwnedNo : ""}
                  />
                </FormControl>
              </form>
              <StepButtons
                isSubmitting={isSubmitting}
                activestep={activeStep}
                maxstep={maxStep}
                handleBack={handleBack}
                handleNext={handleSubmit}
              />
            </>
          )}
        </Formik>
      )}
    </Consumer>
  );
});

const MySpouse = withStyles(styles)(function (props) {
  const { activeStep, handleBack, maxStep, classes } = props;

  return (
    <Consumer>
      {(context) => (
        <Formik
          initialValues={{
            spouseFirstName: context.spouseFirstName,
            spouseMiddleName: context.spouseMiddleName,
            spouseLastName: context.spouseLastName,
            spouseCompanyName: context.spouseCompanyName,
            spouseBusinessAddr: context.spouseBusinessAddr,
            spouseBusinessZipCode: context.spouseBusinessZipCode,
            spouseBusinessAreaCode: context.spouseBusinessAreaCode,
            spouseBusinessPhone: context.spouseBusinessPhone,
            spouseMobilePhone: context.spouseMobilePhone,
            spouseGrossAnnualIncome: context.spouseGrossAnnualIncome,
            civilStatus: context.civilStatus,
          }}
          validationSchema={Yup.object().shape({
            // cardNumber1: Yup.string().when("activeCCOtherBanks", {
            //   is: activeCCOtherBanks => activeCCOtherBanks == "YES",
            //   then: Yup.string().required("Please input a card number")
            // }),
            spouseFirstName: Yup.string().when("civilStatus", {
              is: (civilStatus) => civilStatus == "2",
              then: Yup.string()
                .min(2, "First name is too short")
                .max(20, "First name is too long")
                .required("First name is required"),
            }),
            spouseMiddleName: Yup.string().when("civilStatus", {
              is: (civilStatus) => civilStatus == "2",
              then: Yup.string()
                .min(2, "Middle name is too short")
                .max(20, "Middle name is too long")
                .required("Middle name is required"),
            }),
            spouseLastName: Yup.string().when("civilStatus", {
              is: (civilStatus) => civilStatus == "2",
              then: Yup.string()
                .min(2, "Last name is too short")
                .max(20, "Last name is too long")
                .required("Last name is required"),
            }),

            spouseBusinessPhone: Yup.string()
              .matches(/\d\d\d-\d\d\d\d/, "Invalid Number")
              .when("homeAreaCode", {
                is: (spouseBusinessAreaCode) =>
                  spouseBusinessAreaCode != undefined,
                then: Yup.string().required("Home Phone Number is required"),
              }),

            spouseBusinessAreaCode: Yup.string()
              .matches(/\d\d/, "Invalid Area Code")
              .when("homePhone", {
                is: (spouseBusinessPhone) => spouseBusinessPhone != undefined,
                then: Yup.string().required("Area Code is required"),
              }),

            // spouseBusinessPhone: Yup.string().max(30, "Number too long"),

            spouseMobilePhone: Yup.string().matches(
              /\(\d\d\)\s\d\d\d-\d\d\d-\d\d\d\d/,
              "Invalid Mobile Phone Number"
            ),
            spouseBusinessAddr: Yup.string()
              .min(15, "Address is too short")
              .max(120, "Address is too long"),
          })}
          onSubmit={(values, actions) => {
            context.updateState("spouseFirstName", values.spouseFirstName);
            context.updateState("spouseMiddleName", values.spouseMiddleName);
            context.updateState("spouseLastName", values.spouseLastName);
            context.updateState("spouseCompanyName", values.spouseCompanyName);
            context.updateState(
              "spouseBusinessAddr",
              values.spouseBusinessAddr
            );
            context.updateState(
              "spouseBusinessZipCode",
              values.spouseBusinessZipCode
            );
            context.updateState(
              "spouseBusinessAreaCode",
              values.spouseBusinessAreaCode
            );
            context.updateState(
              "spouseBusinessPhone",
              values.spouseBusinessPhone
            );
            context.updateState("spouseMobilePhone", values.spouseMobilePhone);
            context.updateState(
              "spouseGrossAnnualIncome",
              values.spouseGrossAnnualIncome
            );

            actions.setSubmitting(false);
            props.handleSubmit();
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <>
              <form noValidate autoComplete="off">
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="spouseFirstName"
                    label="First Name"
                    value={values.spouseFirstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.spouseFirstName && touched.spouseFirstName
                        ? true
                        : false
                    }
                    helperText={
                      touched.spouseFirstName ? errors.spouseFirstName : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="spouseMiddleName"
                    label="Middle Name"
                    value={values.spouseMiddleName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.spouseMiddleName && touched.spouseMiddleName
                        ? true
                        : false
                    }
                    helperText={
                      touched.spouseMiddleName ? errors.spouseMiddleName : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="spouseLastName"
                    label="Last Name"
                    value={values.spouseLastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.spouseLastName && touched.spouseLastName
                        ? true
                        : false
                    }
                    helperText={
                      touched.spouseLastName ? errors.spouseLastName : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="spouseCompanyName"
                    label="Company Name"
                    value={values.spouseCompanyName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.spouseCompanyName && touched.spouseCompanyName
                        ? true
                        : false
                    }
                    helperText={
                      touched.spouseCompanyName ? errors.spouseCompanyName : ""
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="spouseBusinessAddr"
                    label="Business Address"
                    value={values.spouseBusinessAddr}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.spouseBusinessAddr && touched.spouseBusinessAddr
                        ? true
                        : false
                    }
                    helperText={
                      touched.spouseBusinessAddr
                        ? errors.spouseBusinessAddr
                        : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="spouseBusinessZipCode"
                    label="Zip Code"
                    value={values.spouseBusinessZipCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.spouseBusinessZipCode &&
                        touched.spouseBusinessZipCode
                        ? true
                        : false
                    }
                    helperText={
                      touched.spouseBusinessZipCode
                        ? errors.spouseBusinessZipCode
                        : ""
                    }
                    InputProps={{
                      inputComponent: ZipCustom,
                    }}
                  />
                </FormControl>

                {/* <FormControl fullWidth margin="dense">
                  <TextField
                    // required
                    id="spouseBusiness"
                    label="Business Phone"
                    className={classes.textField}
                    value={values.spouseBusiness}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    helperText={
                      errors.spouseBusiness && touched.spouseBusiness
                        ? errors.spouseBusiness
                        : " If provincial, include area code"
                    }
                    error={
                      errors.spouseBusiness && touched.spouseBusiness ? true : false
                    }
                  />
                </FormControl> */}

                <Grid container className={classes.homeNumber}>
                  <FormControl
                    margin="dense"
                    error={errors.spouseBusinessAreaCode ? true : false}
                  >
                    <InputLabel htmlFor="spouseBusinessAreaCode ">
                      Area Code
                    </InputLabel>
                    <Input
                      id="spouseBusinessAreaCode"
                      value={values.spouseBusinessAreaCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.spouseBusinessAreaCode &&
                          touched.spouseBusinessAreaCode
                          ? true
                          : false
                      }
                      inputComponent={HomeAreaCode}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.spouseBusinessAreaCode ||
                        (touched.spouseBusinessAreaCode && (
                          <>{errors.spouseBusinessAreaCode}</>
                        ))}
                    </FormHelperText>
                  </FormControl>

                  <FormControl
                    margin="dense"
                    error={errors.spouseBusinessPhone ? true : false}
                  >
                    <InputLabel htmlFor="spouseBusinessPhone">
                      Business Phone
                    </InputLabel>
                    <Input
                      id="spouseBusinessPhone"
                      value={values.spouseBusinessPhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.spouseBusinessPhone &&
                          touched.spouseBusinessPhone
                          ? true
                          : false
                      }
                      inputComponent={HomeTelCustom2}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.spouseBusinessPhone ||
                        (touched.spouseBusinessPhone && (
                          <>{errors.spouseBusinessPhone}</>
                        ))}
                    </FormHelperText>
                  </FormControl>
                </Grid>

                <FormControl margin="dense">
                  <Typography
                    variant="caption"
                    style={{ color: "rgba(0, 0, 0, 0.54)", marginTop: "-10px" }}
                  >
                    Include local/extension and if provincial, area code{" "}
                  </Typography>
                </FormControl>

                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.spouseMobilePhone && touched.spouseMobilePhone
                      ? true
                      : false
                  }
                >
                  <InputLabel required htmlFor="spouseMobilePhone">
                    Mobile Phone
                  </InputLabel>
                  <Input
                    id="spouseMobilePhone"
                    value={values.spouseMobilePhone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.spouseMobilePhone && touched.spouseMobilePhone
                        ? true
                        : false
                    }
                    inputComponent={MobileCustom}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.spouseMobilePhone && touched.spouseMobilePhone && (
                      <>{errors.spouseMobilePhone}</>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="spouseGrossAnnualIncome"
                    label="Gross Annual Income"
                    value={values.spouseGrossAnnualIncome}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched.spouseGrossAnnualIncome
                        ? errors.spouseGrossAnnualIncome
                        : "Should match income document submitted"
                    }
                    error={
                      errors.spouseGrossAnnualIncome &&
                        touched.spouseGrossAnnualIncome
                        ? true
                        : false
                    }
                    InputProps={{
                      inputComponent: CurrencyCustom,
                    }}
                  />
                </FormControl>
              </form>
              <StepButtons
                isSubmitting={isSubmitting}
                activestep={activeStep}
                maxstep={maxStep}
                handleBack={handleBack}
                handleNext={handleSubmit}
              />
            </>
          )}
        </Formik>
      )}
    </Consumer>
  );
});

const MyPersonalReferences = withStyles(styles)(function (props) {
  const { activeStep, handleBack, maxStep, classes } = props;

  return (
    <Consumer>
      {(context) => (
        <Formik
          initialValues={{
            reference1FirstName: context.reference1FirstName,
            reference1MiddleName: context.reference1MiddleName,
            reference1LastName: context.reference1LastName,
            reference1businessName: context.reference1businessName,
            reference1bussinessAddr: context.reference1bussinessAddr,
            reference1ZipCode: context.reference1ZipCode,
            reference1BusinessPhone: context.reference1BusinessPhone,
            reference1BusinessAreaCode: context.reference1BusinessAreaCode,
            reference1MobilePhone: context.reference1MobilePhone,
            reference1HomeAreaCode: context.reference1HomeAreaCode,
            reference1HomePhone: context.reference1HomePhone,
            reference2FirstName: context.reference2FirstName,
            reference2MiddleName: context.reference2MiddleName,
            reference2LastName: context.reference2LastName,
            reference2businessName: context.reference2businessName,
            reference2bussinessAddr: context.reference2bussinessAddr,
            reference2ZipCode: context.reference2ZipCode,
            reference2BusinessPhone: context.reference2BusinessPhone,
            reference2BusinessAreaCode: context.reference2BusinessAreaCode,
            reference2MobilePhone: context.reference2MobilePhone,
            reference2HomeAreaCode: context.reference2HomeAreaCode,
            reference2HomePhone: context.reference2HomePhone,
          }}
          validationSchema={Yup.object().shape(
            {
              reference1FirstName: Yup.string()
                .min(2, "First name is too short")
                .max(20, "First name is too long")
                .required("First name is required"),
              reference1MiddleName: Yup.string()
                .min(2, "Middle name is too short")
                .max(20, "Middle name is too long")
                .required("Middle name is required"),
              reference1LastName: Yup.string()
                .min(2, "Last name is too short")
                .max(20, "Last name is too long")
                .required("Last name is required"),

              // reference1BusinessPhone: Yup.string().max(30, "Number too long"),

              reference1BusinessPhone: Yup.string()
                .matches(/\d\d\d-\d\d\d\d/, "Invalid Number")
                .when("reference1BusinessAreaCode", {
                  is: (reference1BusinessAreaCode) =>
                    reference1BusinessAreaCode != undefined,
                  then: Yup.string().required(
                    "Business Phone Number is required"
                  ),
                }),

              reference1BusinessAreaCode: Yup.string()
                .matches(/\d\d/, "Invalid Area Code")
                .when("homePhone", {
                  is: (reference1BusinessPhone) =>
                    reference1BusinessPhone != undefined,
                  then: Yup.string().required("Area Code is required"),
                }),

              reference1HomePhone: Yup.string()
                .matches(/\d\d\d-\d\d\d\d/, "Invalid Number")
                .when("reference1HomeAreaCode", {
                  is: (reference1HomeAreaCode) =>
                    reference1HomeAreaCode != undefined,
                  then: Yup.string().required("Home Phone Number is required"),
                }),

              reference1HomeAreaCode: Yup.string()
                .matches(/\d\d/, "Invalid Area Code")
                .when("reference1HomePhone", {
                  is: (reference1HomePhone) => reference1HomePhone != undefined,
                  then: Yup.string().required("Area Code is required"),
                }),
              reference1MobilePhone: Yup.string()
                .matches(
                  /\(\d\d\)\s\d\d\d-\d\d\d-\d\d\d\d/,
                  "Invalid Mobile Phone Number"
                )
                .required("Mobile Phone Number is required"),
              reference1bussinessAddr: Yup.string()
                .min(15, "Address is too short")
                .max(120, "Address is too long"),
              reference2bussinessAddr: Yup.string()
                .min(15, "Address is too short")
                .max(120, "Address is too long"),
              reference2FirstName: Yup.string()
                .min(2, "First name is too short")
                .max(20, "First name is too long")
                .required("First name is required"),
              reference2MiddleName: Yup.string()
                .min(2, "Middle name is too short")
                .max(20, "Middle name is too long")
                .required("Middle name is required"),
              reference2LastName: Yup.string()
                .min(2, "Last name is too short")
                .max(20, "Last name is too long")
                .required("Last name is required"),
              reference2HomePhone: Yup.string()
                .matches(/\d\d\d-\d\d\d\d/, "Invalid Number")
                .when("reference2HomeAreaCode", {
                  is: (reference2HomeAreaCode) =>
                    reference2HomeAreaCode != undefined,
                  then: Yup.string().required("Home Phone Number is required"),
                }),

              reference2HomeAreaCode: Yup.string()
                .matches(/\d\d/, "Invalid Area Code")
                .when("reference2HomePhone", {
                  is: (reference2HomePhone) => reference2HomePhone != undefined,
                  then: Yup.string().required("Area Code is required"),
                }),
              // reference2BusinessPhone: Yup.string().max(30, "Number too long"),
              reference2BusinessPhone: Yup.string()
                .matches(/\d\d\d-\d\d\d\d/, "Invalid Number")
                .when("reference2BusinessAreaCode", {
                  is: (reference2BusinessAreaCode) =>
                    reference2BusinessAreaCode != undefined,
                  then: Yup.string().required(
                    "Business Phone Number is required"
                  ),
                }),

              reference2BusinessAreaCode: Yup.string()
                .matches(/\d\d/, "Invalid Area Code")
                .when("homePhone", {
                  is: (reference2BusinessPhone) =>
                    reference2BusinessPhone != undefined,
                  then: Yup.string().required("Area Code is required"),
                }),
              reference2MobilePhone: Yup.string()
                .matches(
                  /\(\d\d\)\s\d\d\d-\d\d\d-\d\d\d\d/,
                  "Invalid Mobile Phone Number"
                )
                .required("Mobile Phone Number is required"),
            },
            [
              ["reference1HomePhone", "reference1HomeAreaCode"],
              ["reference2HomePhone", "reference2HomeAreaCode"],
            ]
          )}
          onSubmit={(values, actions) => {
            context.updateState(
              "reference1FirstName",
              values.reference1FirstName
            );
            context.updateState(
              "reference1MiddleName",
              values.reference1MiddleName
            );
            context.updateState(
              "reference1LastName",
              values.reference1LastName
            );
            context.updateState(
              "reference1businessName",
              values.reference1businessName
            );
            context.updateState(
              "reference1bussinessAddr",
              values.reference1bussinessAddr
            );
            context.updateState("reference1ZipCode", values.reference1ZipCode);
            context.updateState(
              "reference1BusinessPhone",
              values.reference1BusinessPhone
            );
            context.updateState(
              "reference1BusinessAreaCode",
              values.reference1BusinessAreaCode
            );
            context.updateState(
              "reference1MobilePhone",
              values.reference1MobilePhone
            );
            context.updateState(
              "reference1HomeAreaCode",
              values.reference1HomeAreaCode
            );
            context.updateState(
              "reference1HomePhone",
              values.reference1HomePhone
            );
            context.updateState(
              "reference2FirstName",
              values.reference2FirstName
            );
            context.updateState(
              "reference2MiddleName",
              values.reference2MiddleName
            );
            context.updateState(
              "reference2LastName",
              values.reference2LastName
            );
            context.updateState(
              "reference2businessName",
              values.reference2businessName
            );
            context.updateState(
              "reference2bussinessAddr",
              values.reference2bussinessAddr
            );
            context.updateState("reference2ZipCode", values.reference2ZipCode);
            context.updateState(
              "reference2BusinessPhone",
              values.reference2BusinessPhone
            );
            context.updateState(
              "reference2BusinessAreaCode",
              values.reference2BusinessAreaCode
            );
            context.updateState(
              "reference2MobilePhone",
              values.reference2MobilePhone
            );
            context.updateState(
              "reference2HomeAreaCode",
              values.reference2HomeAreaCode
            );
            context.updateState(
              "reference2HomePhone",
              values.reference2HomePhone
            );
            // context.updateState("spouseFirstName", values.spouseFirstName);

            actions.setSubmitting(false);
            props.handleSubmit();
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <>
              <form noValidate autoComplete="off">
                <Typography variant="body1">Reference 1</Typography>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="reference1FirstName"
                    label="First Name"
                    value={values.reference1FirstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference1FirstName && touched.reference1FirstName
                        ? true
                        : false
                    }
                    helperText={
                      touched.reference1FirstName
                        ? errors.reference1FirstName
                        : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="reference1MiddleName"
                    label="Middle Name"
                    value={values.reference1MiddleName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference1MiddleName &&
                        touched.reference1MiddleName
                        ? true
                        : false
                    }
                    helperText={
                      touched.reference1MiddleName
                        ? errors.reference1MiddleName
                        : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="reference1LastName"
                    label="Last Name"
                    value={values.reference1LastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference1LastName && touched.reference1LastName
                        ? true
                        : false
                    }
                    helperText={
                      touched.reference1LastName
                        ? errors.reference1LastName
                        : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="reference1CompanyName"
                    label="Company Name"
                    value={values.reference1CompanyName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference1CompanyName &&
                        touched.reference1CompanyName
                        ? true
                        : false
                    }
                    helperText={
                      touched.reference1CompanyName
                        ? errors.reference1CompanyName
                        : ""
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="reference1BusinessAddr"
                    label="Business Address"
                    value={values.reference1BusinessAddr}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference1BusinessAddr &&
                        touched.reference1BusinessAddr
                        ? true
                        : false
                    }
                    helperText={
                      touched.reference1BusinessAddr
                        ? errors.reference1BusinessAddr
                        : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="reference1BusinessZipCode"
                    label="Zip Code"
                    value={values.reference1BusinessZipCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference1BusinessZipCode &&
                        touched.reference1BusinessZipCode
                        ? true
                        : false
                    }
                    helperText={
                      touched.reference1BusinessZipCode
                        ? errors.reference1BusinessZipCode
                        : ""
                    }
                    InputProps={{
                      inputComponent: ZipCustom,
                    }}
                  />
                </FormControl>

                {/* <FormControl fullWidth margin="dense">
                  <TextField
                    // required
                    id="reference1BusinessPhone"
                    label="Business Phone"
                    className={classes.textField}
                    value={values.reference1BusinessPhone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    helperText={
                      errors.reference1BusinessPhone && touched.reference1BusinessPhone
                        ? errors.reference1BusinessPhone
                        : " If provincial, include area code"
                    }
                    error={
                      errors.reference1BusinessPhone && touched.reference1BusinessPhone ? true : false
                    }
                  />
                </FormControl> */}

                <Grid container className={classes.homeNumber}>
                  <FormControl
                    margin="dense"
                    error={errors.reference1BusinessAreaCode ? true : false}
                  >
                    <InputLabel htmlFor="reference1BusinessAreaCode ">
                      Area Code
                    </InputLabel>
                    <Input
                      id="reference1BusinessAreaCode"
                      value={values.reference1BusinessAreaCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.reference1BusinessAreaCode &&
                          touched.reference1BusinessAreaCode
                          ? true
                          : false
                      }
                      inputComponent={HomeAreaCode}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.reference1BusinessAreaCode ||
                        (touched.reference1BusinessAreaCode && (
                          <>{errors.reference1BusinessAreaCode}</>
                        ))}
                    </FormHelperText>
                  </FormControl>

                  <FormControl
                    required
                    margin="dense"
                    error={errors.spousePhone ? true : false}
                  >
                    <InputLabel htmlFor="reference1BusinessPhone" required>
                      Business Phone
                    </InputLabel>
                    <Input
                      required
                      id="reference1BusinessPhone"
                      value={values.reference1BusinessPhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.reference1BusinessPhone &&
                          touched.reference1BusinessPhone
                          ? true
                          : false
                      }
                      inputComponent={HomeTelCustom2}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                      style={{ color: "red" }}
                    >
                      {errors.reference1BusinessPhone ||
                        (touched.reference1BusinessPhone && (
                          <>{errors.reference1BusinessPhone}</>
                        ))}
                    </FormHelperText>
                  </FormControl>
                </Grid>

                <FormControl margin="dense">
                  <Typography
                    variant="caption"
                    style={{ color: "rgba(0, 0, 0, 0.54)", marginTop: "-10px" }}
                  >
                    Include local/extension and if provincial, area code{" "}
                  </Typography>
                </FormControl>

                <Grid container className={classes.homeNumber}>
                  <FormControl
                    // fullWidth
                    margin="dense"
                    error={errors.reference1HomeAreaCode ? true : false}
                  >
                    <InputLabel htmlFor="reference1HomeAreaCode">
                      Area Code
                    </InputLabel>
                    <Input
                      // type="number"
                      id="reference1HomeAreaCode"
                      value={values.reference1HomeAreaCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.reference1HomeAreaCode &&
                          touched.reference1HomeAreaCode
                          ? true
                          : false
                      }
                      inputComponent={HomeAreaCode}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.reference1HomeAreaCode ||
                        (touched.reference1HomeAreaCode && (
                          <>{errors.reference1HomeAreaCode}</>
                        ))}
                    </FormHelperText>
                  </FormControl>
                  <FormControl
                    // fullWidth
                    margin="dense"
                    error={errors.reference1HomePhone ? true : false}
                  >
                    <InputLabel htmlFor="reference1HomePhone">
                      Home Phone Number
                    </InputLabel>
                    <Input
                      // type="number"
                      id="reference1HomePhone"
                      value={values.reference1HomePhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.reference1HomePhone &&
                          touched.reference1HomePhone
                          ? true
                          : false
                      }
                      inputComponent={HomeTelCustom2}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.reference1HomePhone ||
                        (touched.reference1HomePhone && (
                          <>{errors.reference1HomePhone}</>
                        ))}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.reference1MobilePhone &&
                      touched.reference1MobilePhone
                      ? true
                      : false
                  }
                >
                  <InputLabel required htmlFor="reference1MobilePhone">
                    Mobile Phone
                  </InputLabel>
                  <Input
                    id="reference1MobilePhone"
                    value={values.reference1MobilePhone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference1MobilePhone &&
                        touched.reference1MobilePhone
                        ? true
                        : false
                    }
                    inputComponent={MobileCustom}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.reference1MobilePhone &&
                      touched.reference1MobilePhone && (
                        <>{errors.reference1MobilePhone}</>
                      )}
                  </FormHelperText>
                </FormControl>
                <br />
                <br />
                <Typography variant="body1">Reference 2</Typography>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="reference2FirstName"
                    label="First Name"
                    value={values.reference2FirstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference2FirstName && touched.reference2FirstName
                        ? true
                        : false
                    }
                    helperText={
                      touched.reference2FirstName
                        ? errors.reference2FirstName
                        : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="reference2MiddleName"
                    label="Middle Name"
                    value={values.reference2MiddleName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference2MiddleName &&
                        touched.reference2MiddleName
                        ? true
                        : false
                    }
                    helperText={
                      touched.reference2MiddleName
                        ? errors.reference2MiddleName
                        : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="reference2LastName"
                    label="Last Name"
                    value={values.reference2LastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference2LastName && touched.reference2LastName
                        ? true
                        : false
                    }
                    helperText={
                      touched.reference2LastName
                        ? errors.reference2LastName
                        : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="reference2CompanyName"
                    label="Company Name"
                    value={values.reference2CompanyName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference2CompanyName &&
                        touched.reference2CompanyName
                        ? true
                        : false
                    }
                    helperText={
                      touched.reference2CompanyName
                        ? errors.reference2CompanyName
                        : ""
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="reference2BusinessAddr"
                    label="Business Address"
                    value={values.reference2BusinessAddr}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference2BusinessAddr &&
                        touched.reference2BusinessAddr
                        ? true
                        : false
                    }
                    helperText={
                      touched.reference2BusinessAddr
                        ? errors.reference2BusinessAddr
                        : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="reference2BusinessZipCode"
                    label="Zip Code"
                    value={values.reference2BusinessZipCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference2BusinessZipCode &&
                        touched.reference2BusinessZipCode
                        ? true
                        : false
                    }
                    helperText={
                      touched.reference2BusinessZipCode
                        ? errors.reference2BusinessZipCode
                        : ""
                    }
                    InputProps={{
                      inputComponent: ZipCustom,
                    }}
                  />
                </FormControl>

                {/* <FormControl fullWidth margin="dense">
                  <TextField
                    // required
                    id="reference2BusinessPhone"
                    label="Business Phone"
                    className={classes.textField}
                    value={values.reference2BusinessPhone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    helperText={
                      errors.reference2BusinessPhone && touched.reference2BusinessPhone
                        ? errors.reference2BusinessPhone
                        : " If provincial, include area code"
                    }
                    error={
                      errors.reference2BusinessPhone && touched.reference2BusinessPhone ? true : false
                    }
                  />
                </FormControl> */}

                <Grid container className={classes.homeNumber}>
                  <FormControl
                    margin="dense"
                    error={errors.reference2BusinessAreaCode ? true : false}
                  >
                    <InputLabel htmlFor="reference2BusinessAreaCode ">
                      Area Code
                    </InputLabel>
                    <Input
                      id="reference2BusinessAreaCode"
                      value={values.reference2BusinessAreaCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.reference2BusinessAreaCode &&
                          touched.reference2BusinessAreaCode
                          ? true
                          : false
                      }
                      inputComponent={HomeAreaCode}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.reference2BusinessAreaCode ||
                        (touched.reference2BusinessAreaCode && (
                          <>{errors.reference2BusinessAreaCode}</>
                        ))}
                    </FormHelperText>
                  </FormControl>

                  <FormControl
                    margin="dense"
                    error={errors.spousePhone ? true : false}
                    required
                  >
                    <InputLabel htmlFor="reference2BusinessPhone" req>
                      Business Phone
                    </InputLabel>
                    <Input
                      id="reference2BusinessPhone"
                      value={values.reference2BusinessPhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.reference2BusinessPhone &&
                          touched.reference2BusinessPhone
                          ? true
                          : false
                      }
                      inputComponent={HomeTelCustom2}
                      required
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                      style={{ color: "red" }}
                    >
                      {errors.reference2BusinessPhone ||
                        (touched.reference2BusinessPhone && (
                          <>{errors.reference2BusinessPhone}</>
                        ))}
                    </FormHelperText>
                  </FormControl>
                </Grid>

                <FormControl margin="dense">
                  <Typography
                    variant="caption"
                    style={{ color: "rgba(0, 0, 0, 0.54)", marginTop: "-10px" }}
                  >
                    Include local/extension and if provincial, area code{" "}
                  </Typography>
                </FormControl>

                <Grid container className={classes.homeNumber}>
                  <FormControl
                    // fullWidth
                    margin="dense"
                    error={errors.reference2HomeAreaCode ? true : false}
                  >
                    <InputLabel htmlFor="reference2HomeAreaCode">
                      Area Code
                    </InputLabel>
                    <Input
                      // type="number"
                      id="reference2HomeAreaCode"
                      value={values.reference2HomeAreaCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.reference2HomeAreaCode &&
                          touched.reference2HomeAreaCode
                          ? true
                          : false
                      }
                      inputComponent={HomeAreaCode}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.reference2HomeAreaCode ||
                        (touched.reference2HomeAreaCode && (
                          <>{errors.reference2HomeAreaCode}</>
                        ))}
                    </FormHelperText>
                  </FormControl>
                  <FormControl
                    // fullWidth
                    margin="dense"
                    error={errors.reference2HomePhone ? true : false}
                  >
                    <InputLabel htmlFor="reference2HomePhone">
                      Home Phone Number
                    </InputLabel>
                    <Input
                      // type="number"
                      id="reference2HomePhone"
                      value={values.reference2HomePhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.reference2HomePhone &&
                          touched.reference2HomePhone
                          ? true
                          : false
                      }
                      inputComponent={HomeTelCustom2}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.reference2HomePhone ||
                        (touched.reference2HomePhone && (
                          <>{errors.reference2HomePhone}</>
                        ))}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.reference2MobilePhone &&
                      touched.reference2MobilePhone
                      ? true
                      : false
                  }
                >
                  <InputLabel required htmlFor="reference2MobilePhone">
                    Mobile Phone
                  </InputLabel>
                  <Input
                    id="reference2MobilePhone"
                    value={values.reference2MobilePhone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.reference2MobilePhone &&
                        touched.reference2MobilePhone
                        ? true
                        : false
                    }
                    inputComponent={MobileCustom}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.reference2MobilePhone &&
                      touched.reference2MobilePhone && (
                        <>{errors.reference2MobilePhone}</>
                      )}
                  </FormHelperText>
                </FormControl>
              </form>
              <StepButtons
                isSubmitting={isSubmitting}
                activestep={activeStep}
                maxstep={maxStep}
                handleBack={handleBack}
                handleNext={handleSubmit}
              />
            </>
          )}
        </Formik>
      )}
    </Consumer>
  );
});

const MyWorkAndFinances = withStyles(styles)(function (props) {
  const { activeStep, handleBack, maxStep, classes } = props;

  return (
    <Consumer>
      {(context) => (
        <Formik
          initialValues={{
            employment: context.employment,
            employmentOther: context.employmentOther,
            presentEmployerNoYrs: context.presentEmployerNoYrs,
            totalNoYrsWorking: context.totalNoYrsWorking,
            position: context.position,
            positionOther: context.positionOther,
            positionTitle: context.positionTitle,
            natureOfPresentBusiness: context.natureOfPresentBusiness,
            natureOfPresentBusinessOther: context.natureOfPresentBusinessOther,
            sourceOfFunds: context.sourceOfFunds,
            sourceOfFundsOther: context.sourceOfFundsOther,
            occupation: context.occupation,
            occupationOther: context.occupationOther,
            companyName: context.companyName,
            department: context.department,
            businessAddr: context.businessAddr,
            businessZipCode: context.businessZipCode,
            businessAreaCode: context.businessAreaCode,
            businessPhone: context.businessPhone,
            businessEmail: context.businessEmail,
            grossAnnualIncome: context.grossAnnualIncome,
            existingEWDepositor: context.existingEWDepositor,
            bankAccountNo: context.bankAccountNo,
            existingEWCCholder: context.existingEWCCholder,
            CCNo: context.CCNo,
            bank1: context.bank1,
            loanType1: context.loanType1,
            monthlyAmortization1: context.monthlyAmortization1,
            bank2: context.bank2,
            loanType2: context.loanType2,
            monthlyAmortization2: context.monthlyAmortization2,
            bank3: context.bank3,
            loanType3: context.loanType3,
            monthlyAmortization3: context.monthlyAmortization3,
            activeCCOtherBanks: context.activeCCOtherBanks,
            CCReference: context.CCReference,
            cardIssuer1: context.cardIssuer1,
            cardNumber1: context.cardNumber1,
            memberSince1: context.memberSince1,
            creditLimit1: context.creditLimit1,
            cardIssuer2: context.cardIssuer2,
            cardNumber2: context.cardNumber2,
            memberSince2: context.memberSince2,
            creditLimit2: context.creditLimit2,
            cardIssuer3: context.cardIssuer3,
            cardNumber3: context.cardNumber3,
            memberSince3: context.memberSince3,
            creditLimit3: context.creditLimit3,
          }}
          validationSchema={Yup.object().shape({
            employment: Yup.string().required(
              "Please input a valid employment"
            ),

            employmentOther: Yup.object().when("employment", {
              is: function (value) {
                var x = value;
                console.log();
                return value == "5";
              },
              then: Yup.string()
                .max(120, "Invalid input")
                .required("Please select employment"),
            }),
            presentEmployerNoYrs: Yup.string()
              .max(
                2,
                "Total Number of Years with present employer/business is invalid"
              )
              .required(
                "No. of Years w/ Present Employer/Business is required "
              ),
            totalNoYrsWorking: Yup.number()
              .positive("Invalid Entry")
              .integer()
              .min(0, "Invalid Entry")
              .max(70, "Invalid Entry"),

            position: Yup.string().required("Please select position"),
            positionOther: Yup.string().when("position", {
              is: (position) => position == "11",
              then: Yup.string()
                .max(120, "Invalid input")
                .required("Please select position"),
            }),
            positionTitle: Yup.string().required("Position title is required"),
            natureOfPresentBusiness: Yup.string().required(
              "Please select nature of present business"
            ),
            natureOfPresentBusinessOther: Yup.string().when(
              "natureOfPresentBusiness",
              {
                is: (natureOfPresentBusiness) =>
                  natureOfPresentBusiness == "13",
                then: Yup.string().required(
                  "Please select nature of present business"
                ),
              }
            ),
            sourceOfFunds: Yup.string().required(
              "Please select Source of Income/Wealth "
            ),
            sourceOfFundsOther: Yup.string().when("sourceOfFunds", {
              is: (sourceOfFunds) => sourceOfFunds == "7",
              then: Yup.string()
                .max(120, "Invalid input")
                .required("Please select Source of Income/Wealth"),
            }),
            occupation: Yup.string().required("Please select occupation"),
            occupationOther: Yup.string().when("occupation", {
              is: (occupation) => occupation == "10",
              then: Yup.string()
                .max(120, "Invalid input")
                .required("Please select occupation"),
            }),
            companyName: Yup.string()
              .min(2, "Company name is too short")
              .max(30, "Company name is too long")
              .required("Company name is required"),
            department: Yup.string()
              .min(2, "Department name is too short")
              .max(30, "Department name is too long"),
            businessAddr: Yup.string()
              .min(15, "Business Address is too short")
              .max(120, "Business Address name is too long")
              .required("Business Address is required"),
            businessZipCode: Yup.string()
              .matches(/\d\d\d\d/, "Zip code is required")
              .required("Zip code is required"),

            // businessPhone: Yup.string()
            // .max(30, "Number too long")
            // .required("Business Phone Number is required"),

            businessPhone: Yup.string()
              .matches(/\d\d\d-\d\d\d\d/, "Invalid Number")
              .when("homeAreaCode", {
                is: (businessAreaCode) => businessAreaCode != undefined,
                then: Yup.string().required("Home Phone Number is required"),
              })
              .required(THIS_FIELD_IS_REQUIRED),

            businessAreaCode: Yup.string()
              .matches(/\d\d/, "Invalid Area Code")
              .when("homePhone", {
                is: (businessPhone) => businessPhone != undefined,
                then: Yup.string().required("Area Code is required"),
              }),

            businessEmail: Yup.string().email().max(50, "Email is too long"),
            grossAnnualIncome: Yup.string().required("This is required"),
            existingEWDepositor: Yup.string().required(
              "Please select an option"
            ),
            bankAccountNo: Yup.string().when("existingEWDepositor", {
              is: (existingEWDepositor) => existingEWDepositor == "Yes",
              then: Yup.string()
                .max(12, "Invalid input, max 12 digits")
                .required("Please type your bank account no."),
            }),
            existingEWCCholder: Yup.string().required(
              "Please select an option"
            ),
            CCNo: Yup.string().when("existingEWCCholder", {
              is: (existingEWCCholder) => existingEWCCholder == "Yes",
              then: Yup.string()
                .max(16, "Invalid input, max 16 digits")
                .required("Please select type your credit card no."),
            }),
            bank1: Yup.string().max(120, "Invalid Input"),
            loanType1: Yup.string().max(120, "Invalid Input"),
            bank2: Yup.string().max(120, "Invalid Input"),
            loanType2: Yup.string().max(120, "Invalid Input"),
            bank3: Yup.string().max(120, "Invalid Input"),
            loanType3: Yup.string().max(120, "Invalid Input"),
            activeCCOtherBanks: Yup.string().required(
              "This is a required field"
            ),
            cardIssuer1: Yup.string().when("activeCCOtherBanks", {
              is: (activeCCOtherBanks) => activeCCOtherBanks == "Yes",
              then: Yup.string().required("Please select a card issuer"),
            }),
            cardNumber1: Yup.string().when("activeCCOtherBanks", {
              is: (activeCCOtherBanks) => activeCCOtherBanks == "Yes",
              then: Yup.string()
                .max(16, "Invalid input, max 16 digits")
                .required("Please input a card number"),
            }),
            memberSince1: Yup.string().when("activeCCOtherBanks", {
              is: (activeCCOtherBanks) => activeCCOtherBanks == "Yes",
              then: Yup.string().required("Please validate"),
              // then: Yup.string().matches(/\d\d\/\\d\d\d\d/, "Invalid Phone Number").required('Please validate')
            }),
            creditLimit1: Yup.string().when("activeCCOtherBanks", {
              is: (activeCCOtherBanks) => activeCCOtherBanks == "Yes",
              then: Yup.string().required("Please input a credit limit"),
            }),
            cardIssuer2: Yup.string().max(20, "Invalid input"),
            cardNumber2: Yup.string().max(16, "Invalid input, max 16 digits"),
            cardIssuer3: Yup.string().max(20, "Invalid input"),
            cardNumber3: Yup.string().max(16, "Invalid input, max 16 digits"),
          })}
          onSubmit={(values, actions) => {
            context.updateState("employment", values.employment);
            context.updateState("employmentOther", values.employmentOther);
            context.updateState(
              "presentEmployerNoYrs",
              values.presentEmployerNoYrs
            );
            context.updateState("totalNoYrsWorking", values.totalNoYrsWorking);
            context.updateState("position", values.position);
            context.updateState("positionOther", values.positionOther);
            context.updateState("positionTitle", values.positionTitle);
            context.updateState(
              "natureOfPresentBusiness",
              values.natureOfPresentBusiness
            );
            context.updateState(
              "natureOfPresentBusinessOther",
              values.natureOfPresentBusinessOther
            );
            context.updateState("sourceOfFunds", values.sourceOfFunds);
            context.updateState(
              "sourceOfFundsOther",
              values.sourceOfFundsOther
            );
            context.updateState("occupation", values.occupation);
            context.updateState("occupationOther", values.occupationOther);
            context.updateState("companyName", values.companyName);
            context.updateState("department", values.department);
            context.updateState("businessAddr", values.businessAddr);
            context.updateState("businessZipCode", values.businessZipCode);
            context.updateState("businessAreaCode", values.businessAreaCode);
            context.updateState("businessPhone", values.businessPhone);
            context.updateState("businessEmail", values.businessEmail);
            context.updateState("grossAnnualIncome", values.grossAnnualIncome);
            context.updateState(
              "existingEWDepositor",
              values.existingEWDepositor
            );
            context.updateState("bankAccountNo", values.bankAccountNo);
            context.updateState(
              "existingEWCCholder",
              values.existingEWCCholder
            );
            context.updateState("CCNo", values.CCNo);
            context.updateState("bank1", values.bank1);
            context.updateState("loanType1", values.loanType1);
            context.updateState(
              "monthlyAmortization1",
              values.monthlyAmortization1
            );
            context.updateState("bank2", values.bank2);
            context.updateState("loanType2", values.loanType2);
            context.updateState(
              "monthlyAmortization2",
              values.monthlyAmortization2
            );
            context.updateState("bank3", values.bank3);
            context.updateState("loanType3", values.loanType3);
            context.updateState(
              "monthlyAmortization3",
              values.monthlyAmortization3
            );
            context.updateState(
              "activeCCOtherBanks",
              values.activeCCOtherBanks
            );
            context.updateState("cardIssuer1", values.cardIssuer1);
            context.updateState("cardNumber1", values.cardNumber1);
            context.updateState("memberSince1", values.memberSince1);
            context.updateState("creditLimit1", values.creditLimit1);
            context.updateState("cardIssuer2", values.cardIssuer2);
            context.updateState("cardNumber2", values.cardNumber2);
            context.updateState("memberSince2", values.memberSince2);
            context.updateState("creditLimit2", values.creditLimit2);
            context.updateState("cardIssuer3", values.cardIssuer3);
            context.updateState("cardNumber3", values.cardNumber3);
            context.updateState("memberSince3", values.memberSince3);
            context.updateState("creditLimit3", values.creditLimit3);

            actions.setSubmitting(false);
            props.handleSubmit();
            // console.log(values.firstName)
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            /* and other goodies */
          }) => (
            <>
              <form noValidate autoComplete="off">
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.employment && touched.employment ? true : false}
                >
                  <InputLabel required htmlFor="employment">
                    Employment
                  </InputLabel>
                  <SpecialSelect
                    id="employment"
                    name="employment"
                    value={values.employment}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={employmentList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.employment && touched.employment && (
                      <>{errors.employment}</>
                    )}
                  </FormHelperText>
                </FormControl>
                {values.employment == "5" ? (
                  <FormControl fullWidth margin="dense">
                    <TextField
                      color="primary"
                      id="employmentOther"
                      label="Others"
                      value={values.employmentOther}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.employmentOther && touched.employmentOther
                          ? true
                          : false
                      }
                      helperText={
                        touched.employmentOther ? errors.employmentOther : ""
                      }
                    />
                  </FormControl>
                ) : (
                  ""
                )}

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    type="number"
                    id="presentEmployerNoYrs"
                    label="No. of Years w/ Present Business:"
                    value={values.presentEmployerNoYrs}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.presentEmployerNoYrs &&
                        touched.presentEmployerNoYrs
                        ? true
                        : false
                    }
                    helperText={
                      touched.presentEmployerNoYrs
                        ? errors.presentEmployerNoYrs
                        : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    type="number"
                    id="totalNoYrsWorking"
                    label="Total No. of Years Working"
                    value={values.totalNoYrsWorking}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.totalNoYrsWorking && touched.totalNoYrsWorking
                        ? true
                        : false
                    }
                    helperText={
                      touched.totalNoYrsWorking ? errors.totalNoYrsWorking : ""
                    }
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.position && touched.position ? true : false}
                >
                  <InputLabel required htmlFor="position">
                    Position
                  </InputLabel>
                  <SpecialSelect
                    id="position"
                    name="position"
                    value={values.position}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={positionList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.position && touched.position && (
                      <>{errors.position}</>
                    )}
                  </FormHelperText>
                </FormControl>
                {values.position == "11" ? (
                  <FormControl fullWidth margin="dense">
                    <TextField
                      color="primary"
                      id="positionOther"
                      label="Others"
                      value={values.positionOther}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.positionOther && touched.positionOther
                          ? true
                          : false
                      }
                      helperText={
                        touched.positionOther ? errors.positionOther : ""
                      }
                    />
                  </FormControl>
                ) : (
                  ""
                )}
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="positionTitle"
                    label="Position/Title"
                    value={values.positionTitle}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.positionTitle && touched.positionTitle
                        ? true
                        : false
                    }
                    helperText={
                      touched.positionTitle ? errors.positionTitle : ""
                    }
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.natureOfPresentBusiness &&
                      touched.natureOfPresentBusiness
                      ? true
                      : false
                  }
                >
                  <InputLabel required htmlFor="natureOfPresentBusiness">
                    Nature of Present Business
                  </InputLabel>
                  <SpecialSelect
                    id="natureOfPresentBusiness"
                    name="natureOfPresentBusiness"
                    value={values.natureOfPresentBusiness}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={natureOfPresentBusinessList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.natureOfPresentBusiness &&
                      touched.natureOfPresentBusiness && (
                        <>{errors.natureOfPresentBusiness}</>
                      )}
                  </FormHelperText>
                </FormControl>
                {values.natureOfPresentBusiness == "13" ? (
                  <FormControl fullWidth margin="dense">
                    <TextField
                      color="primary"
                      id="natureOfPresentBusinessOther"
                      label="Others"
                      value={values.natureOfPresentBusinessOther}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.natureOfPresentBusinessOther &&
                          touched.natureOfPresentBusinessOther
                          ? true
                          : false
                      }
                      helperText={
                        touched.natureOfPresentBusinessOther
                          ? errors.natureOfPresentBusinessOther
                          : ""
                      }
                    />
                  </FormControl>
                ) : (
                  ""
                )}
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.sourceOfFunds && touched.sourceOfFunds ? true : false
                  }
                >
                  <InputLabel required htmlFor="sourceOfFunds">
                    Source of Income/Wealth
                  </InputLabel>
                  <SpecialSelect
                    id="sourceOfFunds"
                    name="sourceOfFunds"
                    value={values.sourceOfFunds}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={sourceOfFundsList}
                  />

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.sourceOfFunds && touched.sourceOfFunds && (
                      <>{errors.sourceOfFunds}</>
                    )}
                  </FormHelperText>
                </FormControl>
                {values.sourceOfFunds == "7" ? (
                  <FormControl fullWidth margin="dense">
                    <TextField
                      color="primary"
                      id="sourceOfFundsOther"
                      label="Others"
                      value={values.sourceOfFundsOther}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.sourceOfFundsOther && touched.sourceOfFundsOther
                          ? true
                          : false
                      }
                      helperText={
                        touched.sourceOfFundsOther
                          ? errors.sourceOfFundsOther
                          : ""
                      }
                    />
                  </FormControl>
                ) : (
                  ""
                )}
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.occupation && touched.occupation ? true : false}
                >
                  <InputLabel required htmlFor="occupation">
                    Occupation
                  </InputLabel>
                  <SpecialSelect
                    id="occupation"
                    name="occupation"
                    value={values.occupation}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={occupationList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.occupation && touched.occupation && (
                      <>{errors.occupation}</>
                    )}
                  </FormHelperText>
                </FormControl>
                {values.occupation == "10" ? (
                  <FormControl fullWidth margin="dense">
                    <TextField
                      color="primary"
                      id="occupationOther"
                      label="Others"
                      value={values.occupationOther}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.occupationOther && touched.occupationOther
                          ? true
                          : false
                      }
                      helperText={
                        touched.occupationOther ? errors.occupationOther : ""
                      }
                    />
                  </FormControl>
                ) : (
                  ""
                )}
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="companyName"
                    label="Company/Business Name"
                    value={values.companyName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.companyName && touched.companyName ? true : false
                    }
                    helperText={touched.companyName ? errors.companyName : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="department"
                    label="Department"
                    value={values.department}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.department && touched.department ? true : false
                    }
                    helperText={touched.department ? errors.department : ""}
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="businessAddr"
                    label="Business Address"
                    value={values.businessAddr}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.businessAddr && touched.businessAddr ? true : false
                    }
                    helperText={touched.businessAddr ? errors.businessAddr : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="businessZipCode"
                    label="Zip Code"
                    value={values.businessZipCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.businessZipCode && touched.businessZipCode
                        ? true
                        : false
                    }
                    helperText={
                      touched.businessZipCode ? errors.businessZipCode : ""
                    }
                    InputProps={{
                      inputComponent: ZipCustom,
                    }}
                  />
                </FormControl>
                {/* <FormControl fullWidth margin="dense">
                  <TextField
                    // required
                    id="businessPhone"
                    label="Business Phone"
                    className={classes.textField}
                    value={values.businessPhone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    helperText={
                      errors.businessPhone && touched.businessPhone
                        ? errors.businessPhone
                        : " If provincial, include area code"
                    }
                    error={
                      errors.businessPhone && touched.businessPhone ? true : false
                    }
                  />
                </FormControl> */}

                <Grid container className={classes.homeNumber}>
                  <FormControl
                    margin="dense"
                    error={errors.businessAreaCode ? true : false}
                  >
                    <InputLabel htmlFor="businessAreaCode ">
                      Area Code
                    </InputLabel>
                    <Input
                      id="businessAreaCode"
                      value={values.businessAreaCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.businessAreaCode && touched.businessAreaCode
                          ? true
                          : false
                      }
                      inputComponent={HomeAreaCode}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.businessAreaCode ||
                        (touched.businessAreaCode && (
                          <>{errors.businessAreaCode}</>
                        ))}
                    </FormHelperText>
                  </FormControl>

                  <FormControl
                    margin="dense"
                    error={errors.businessPhone ? true : false}
                  >
                    <InputLabel htmlFor="businessPhone" required>
                      Business Phone
                    </InputLabel>
                    <Input
                      required
                      id="businessPhone"
                      value={values.businessPhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.businessPhone && touched.businessPhone
                          ? true
                          : false
                      }
                      inputComponent={HomeTelCustom2}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.businessPhone ||
                        (touched.businessPhone && <>{errors.businessPhone}</>)}
                    </FormHelperText>
                  </FormControl>
                </Grid>

                <FormControl margin="dense">
                  <Typography
                    variant="caption"
                    style={{ color: "rgba(0, 0, 0, 0.54)", marginTop: "-10px" }}
                  >
                    Include local/extension and if provincial, area code{" "}
                  </Typography>
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    type="businessEmail"
                    id="businessEmail"
                    label="Business Email"
                    value={values.businessEmail}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.businessEmail && touched.businessEmail
                        ? true
                        : false
                    }
                    helperText={
                      touched.businessEmail ? errors.businessEmail : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="grossAnnualIncome"
                    label="Gross Annual Income"
                    value={values.grossAnnualIncome}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.grossAnnualIncome && touched.grossAnnualIncome
                        ? true
                        : false
                    }
                    helperText={
                      touched.grossAnnualIncome ? errors.grossAnnualIncome : ""
                    }
                    InputProps={{
                      inputComponent: CurrencyCustom,
                    }}
                  />
                </FormControl>
                <FormControl
                  required
                  className={classes.formRadio}
                  fullWidth
                  error={
                    errors.existingEWDepositor && touched.existingEWDepositor
                      ? true
                      : false
                  }
                >
                  <FormLabel component="legend">
                    Are you an existing EastWest Bank Depositor?
                  </FormLabel>
                  <RadioGroup
                    required
                    aria-label=""
                    name="existingEWDepositor"
                    className={classes.group}
                    value={values.existingEWDepositor}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="NO"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.radioError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.existingEWDepositor &&
                      touched.existingEWDepositor && (
                        <>{errors.existingEWDepositor}</>
                      )}
                  </FormHelperText>
                </FormControl>
                {values.existingEWDepositor === "Yes" ? (
                  <FormControl fullWidth margin="dense">
                    <TextField
                      color="primary"
                      required
                      // onKeyDown={evt => evt.key === "e" && evt.preventDefault()}
                      type="number"
                      id="bankAccountNo"
                      label="Bank Account No."
                      value={values.bankAccountNo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.bankAccountNo && touched.bankAccountNo
                          ? true
                          : false
                      }
                      helperText={
                        touched.bankAccountNo ? errors.bankAccountNo : ""
                      }
                    />
                  </FormControl>
                ) : (
                  ""
                )}

                <FormControl
                  className={classes.formRadio}
                  fullWidth
                  error={
                    errors.existingEWCCholder && touched.existingEWCCholder
                      ? true
                      : false
                  }
                >
                  <FormLabel component="legend">
                    Are you an existing EastWest Bank Credit Cardholder?*
                  </FormLabel>
                  <RadioGroup
                    required
                    aria-label=""
                    name="existingEWCCholder"
                    className={classes.group}
                    value={values.existingEWCCholder}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="NO"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.radioError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.existingEWCCholder &&
                      touched.existingEWCCholder && (
                        <>{errors.existingEWCCholder}</>
                      )}
                  </FormHelperText>
                </FormControl>
                {values.existingEWCCholder === "Yes" ? (
                  <FormControl fullWidth margin="dense">
                    <TextField
                      color="primary"
                      required
                      // onKeyDown={evt => evt.key === "e" && evt.preventDefault()}
                      type="number"
                      id="CCNo"
                      label="Credit Card No."
                      value={values.CCNo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.CCNo && touched.CCNo ? true : false}
                      helperText={touched.CCNo ? errors.CCNo : ""}
                    />
                  </FormControl>
                ) : (
                  ""
                )}

                <br />
                <br />
                <Typography variant="body1">Other Loans 1</Typography>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="bank1"
                    label="Bank"
                    value={values.bank1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.bank1 && touched.bank1 ? true : false}
                    helperText={touched.bank1 ? errors.bank1 : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="loanType1"
                    label="Loan Type"
                    value={values.loanType1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.loanType1 && touched.loanType1 ? true : false}
                    helperText={touched.loanType1 ? errors.loanType1 : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="monthlyAmortization1"
                    label="Monthly Amortization"
                    value={values.monthlyAmortization1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched.monthlyAmortization1
                        ? errors.monthlyAmortization1
                        : "Should match income document submitted"
                    }
                    error={
                      errors.monthlyAmortization1 &&
                        touched.monthlyAmortization1
                        ? true
                        : false
                    }
                    InputProps={{
                      inputComponent: CurrencyCustom,
                    }}
                  />
                </FormControl>

                <br />
                <br />
                <Typography variant="body1">Other Loans 2</Typography>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="bank2"
                    label="Bank"
                    value={values.bank2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.bank2 && touched.bank2 ? true : false}
                    helperText={touched.bank2 ? errors.bank2 : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="loanType2"
                    label="Loan Type"
                    value={values.loanType2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.loanType2 && touched.loanType2 ? true : false}
                    helperText={touched.loanType2 ? errors.loanType2 : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="monthlyAmortization2"
                    label="Monthly Amortization"
                    value={values.monthlyAmortization2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched.monthlyAmortization2
                        ? errors.monthlyAmortization2
                        : "Should match income document submitted"
                    }
                    error={
                      errors.monthlyAmortization2 &&
                        touched.monthlyAmortization2
                        ? true
                        : false
                    }
                    InputProps={{
                      inputComponent: CurrencyCustom,
                    }}
                  />
                </FormControl>
                <br />
                <br />
                <Typography variant="body1">Other Loans 3</Typography>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="bank3"
                    label="Bank"
                    value={values.bank3}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.bank3 && touched.bank3 ? true : false}
                    helperText={touched.bank3 ? errors.bank3 : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="loanType3"
                    label="Loan Type"
                    value={values.loanType3}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.loanType3 && touched.loanType3 ? true : false}
                    helperText={touched.loanType3 ? errors.loanType3 : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="monthlyAmortization3"
                    label="Monthly Amortization"
                    value={values.monthlyAmortization3}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched.monthlyAmortization3
                        ? errors.monthlyAmortization3
                        : "Should match income document submitted"
                    }
                    error={
                      errors.monthlyAmortization3 &&
                        touched.monthlyAmortization3
                        ? true
                        : false
                    }
                    InputProps={{
                      inputComponent: CurrencyCustom,
                    }}
                  />
                </FormControl>

                <FormControl
                  required
                  className={classes.formRadio}
                  fullWidth
                  error={
                    errors.activeCCOtherBanks && touched.activeCCOtherBanks
                      ? true
                      : false
                  }
                >
                  <FormLabel component="legend">
                    Do you have an active credit card with other local banks?
                  </FormLabel>
                  <RadioGroup
                    required
                    aria-label=""
                    name="activeCCOtherBanks"
                    className={classes.group}
                    value={values.activeCCOtherBanks}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="NO"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.radioError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.activeCCOtherBanks &&
                      touched.activeCCOtherBanks && (
                        <>{errors.activeCCOtherBanks}</>
                      )}
                  </FormHelperText>
                </FormControl>

                {values.activeCCOtherBanks === "Yes" ? (
                  <>
                    <br />
                    <br />
                    <Typography variant="body1">
                      Other Credit Card Reference 1
                    </Typography>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        color="primary"
                        required
                        id="cardIssuer1"
                        label="Card Issuer"
                        value={values.cardIssuer1}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          errors.cardIssuer1 && touched.cardIssuer1
                            ? true
                            : false
                        }
                        helperText={
                          touched.cardIssuer1 ? errors.cardIssuer1 : ""
                        }
                      />
                    </FormControl>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        color="primary"
                        required
                        // onKeyDown={evt =>
                        //   evt.key === "e" && evt.preventDefault()
                        // }
                        type="number"
                        id="cardNumber1"
                        label="Card Number"
                        value={values.cardNumber1}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          errors.cardNumber1 && touched.cardNumber1
                            ? true
                            : false
                        }
                        helperText={
                          touched.cardNumber1 ? errors.cardNumber1 : ""
                        }
                      />
                    </FormControl>
                    <FormControl
                      fullWidth
                      margin="dense"
                      error={
                        errors.memberSince1 && touched.memberSince1
                          ? true
                          : false
                      }
                    >
                      <InputLabel required htmlFor="memberSince1">
                        Member Since
                      </InputLabel>
                      <Input
                        id="memberSince1"
                        value={values.memberSince1}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          errors.memberSince1 && touched.memberSince1
                            ? true
                            : false
                        }
                        inputComponent={DateCustom}
                      />
                      <FormHelperText
                        margin="dense"
                        classes={{
                          root: classes.dropdownError,
                          error: classes.error,
                        }}
                        component="p"
                      >
                        {errors.memberSince1 && touched.memberSince1 && (
                          <>{errors.memberSince1}</>
                        )}
                      </FormHelperText>
                    </FormControl>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        required
                        id="creditLimit1"
                        label="Credit Limit"
                        value={values.creditLimit1}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={
                          touched.creditLimit1
                            ? errors.creditLimit1
                            : "Should match income document submitted"
                        }
                        error={
                          errors.creditLimit1 && touched.creditLimit1
                            ? true
                            : false
                        }
                        InputProps={{
                          inputComponent: CurrencyCustom,
                        }}
                      />
                    </FormControl>

                    <br />
                    <br />
                    <Typography variant="body1">
                      Other Credit Card Reference 2
                    </Typography>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        color="primary"
                        id="cardIssuer2"
                        label="Card Issuer"
                        value={values.cardIssuer2}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          errors.cardIssuer2 && touched.cardIssuer2
                            ? true
                            : false
                        }
                        helperText={
                          touched.cardIssuer2 ? errors.cardIssuer2 : ""
                        }
                      />
                    </FormControl>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        color="primary"
                        // onKeyDown={evt =>
                        //   evt.key === "e" && evt.preventDefault()
                        // }
                        type="number"
                        id="cardNumber2"
                        label="Card Number"
                        value={values.cardNumber2}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          errors.cardNumber2 && touched.cardNumber2
                            ? true
                            : false
                        }
                        helperText={
                          touched.cardNumber2 ? errors.cardNumber2 : ""
                        }
                      />
                    </FormControl>
                    <FormControl
                      fullWidth
                      margin="dense"
                      error={
                        errors.memberSince2 && touched.memberSince2
                          ? true
                          : false
                      }
                    >
                      <InputLabel htmlFor="memberSince2">
                        Member Since
                      </InputLabel>
                      <Input
                        id="memberSince2"
                        value={values.memberSince2}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          errors.memberSince2 && touched.memberSince2
                            ? true
                            : false
                        }
                        inputComponent={DateCustom}
                      />
                      <FormHelperText
                        margin="dense"
                        classes={{
                          root: classes.dropdownError,
                          error: classes.error,
                        }}
                        component="p"
                      >
                        {errors.memberSince2 && touched.memberSince2 && (
                          <>{errors.memberSince2}</>
                        )}
                      </FormHelperText>
                    </FormControl>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        // required
                        id="creditLimit2"
                        label="Credit Limit"
                        value={values.creditLimit2}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={
                          touched.creditLimit2
                            ? errors.creditLimit2
                            : "Should match income document submitted"
                        }
                        error={
                          errors.creditLimit2 && touched.creditLimit2
                            ? true
                            : false
                        }
                        InputProps={{
                          inputComponent: CurrencyCustom,
                        }}
                      />
                    </FormControl>

                    <br />
                    <br />
                    <Typography variant="body1">
                      Other Credit Card Reference 3
                    </Typography>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        color="primary"
                        id="cardIssuer3"
                        label="Card Issuer"
                        value={values.cardIssuer3}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          errors.cardIssuer3 && touched.cardIssuer3
                            ? true
                            : false
                        }
                        helperText={
                          touched.cardIssuer3 ? errors.cardIssuer3 : ""
                        }
                      />
                    </FormControl>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        color="primary"
                        // onKeyDown={evt =>
                        //   evt.key === "e" && evt.preventDefault()
                        // }
                        type="number"
                        id="cardNumber3"
                        label="Card Number"
                        value={values.cardNumber3}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          errors.cardNumber3 && touched.cardNumber3
                            ? true
                            : false
                        }
                        helperText={
                          touched.cardNumber3 ? errors.cardNumber3 : ""
                        }
                      />
                    </FormControl>
                    <FormControl
                      fullWidth
                      margin="dense"
                      error={
                        errors.memberSince3 && touched.memberSince3
                          ? true
                          : false
                      }
                    >
                      <InputLabel htmlFor="memberSince3">
                        Member Since
                      </InputLabel>
                      <Input
                        id="memberSince3"
                        value={values.memberSince3}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          errors.memberSince3 && touched.memberSince3
                            ? true
                            : false
                        }
                        inputComponent={DateCustom}
                      />
                      <FormHelperText
                        margin="dense"
                        classes={{
                          root: classes.dropdownError,
                          error: classes.error,
                        }}
                        component="p"
                      >
                        {errors.memberSince3 && touched.memberSince3 && (
                          <>{errors.memberSince3}</>
                        )}
                      </FormHelperText>
                    </FormControl>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        // required
                        id="creditLimit3"
                        label="Credit Limit"
                        value={values.creditLimit3}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={
                          touched.creditLimit3
                            ? errors.creditLimit3
                            : "Should match income document submitted"
                        }
                        error={
                          errors.creditLimit3 && touched.creditLimit3
                            ? true
                            : false
                        }
                        InputProps={{
                          inputComponent: CurrencyCustom,
                        }}
                      />
                    </FormControl>
                  </>
                ) : (
                  ""
                )}
              </form>
              <StepButtons
                isSubmitting={isSubmitting}
                activestep={activeStep}
                maxstep={maxStep}
                handleBack={handleBack}
                handleNext={handleSubmit}
              />
            </>
          )}
        </Formik>
      )}
    </Consumer>
  );
});

const PersonalLoanDetails = withStyles(styles)(function (props) {
  const { activeStep, handleBack, maxStep, classes } = props;

  return (
    <Consumer>
      {(context) => (
        <Formik
          initialValues={{
            loanPurpose: context.loanPurpose,
            loanPurposeOther: context.loanPurposeOther,
            desiredLoanAmount: context.desiredLoanAmount,
            myPreferredPaymentTenor: context.myPreferredPaymentTenor,
            loanLowerAmount: context.loanLowerAmount,
          }}
          validationSchema={Yup.object().shape({
            loanPurpose: Yup.string().required("Please select a loan purpose"),
            loanPurposeOther: Yup.string().when("loanPurpose", {
              is: function (value) {
                // console.log(value);
              },
              then: Yup.string()
                .max(120, "Invalid input")
                .required("This is a required field"),
            }),
            desiredLoanAmount: Yup.string()
              .min(5, "Minimum of 25 thousand pesos")
              .max(13, "Maximum of 2 million pesos")
              .required("Please select a desired loan amount"),
            myPreferredPaymentTenor: Yup.string().required(
              "This is a required field"
            ),
            loanLowerAmount: Yup.string().required(
              "Please select a preferred payment tenor"
            ),
          })}
          onSubmit={(values, actions) => {
            context.updateState("loanPurpose", values.loanPurpose);
            context.updateState("loanPurposeOther", values.loanPurposeOther);
            context.updateState("desiredLoanAmount", values.desiredLoanAmount);
            context.updateState(
              "myPreferredPaymentTenor",
              values.myPreferredPaymentTenor
            );
            context.updateState("loanLowerAmount", values.loanLowerAmount);

            actions.setSubmitting(false);
            props.handleSubmit();
            // console.log(values.firstName)
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            /* and other goodies */
          }) => (
            <>
              <form noValidate autoComplete="off">
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.loanPurpose && touched.loanPurpose ? true : false
                  }
                >
                  <InputLabel required htmlFor="loanPurpose">
                    Loan Purpose
                  </InputLabel>
                  <SpecialSelect
                    id="loanPurpose"
                    name="loanPurpose"
                    value={values.loanPurpose}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={loanPurposeList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.loanPurpose && touched.loanPurpose && (
                      <>{errors.loanPurpose}</>
                    )}
                  </FormHelperText>
                </FormControl>
                {values.loanPurpose == "9" ? (
                  <FormControl fullWidth margin="dense">
                    <TextField
                      required
                      color="primary"
                      id="loanPurposeOther"
                      label="Others"
                      value={values.loanPurposeOther}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.loanPurposeOther && touched.loanPurposeOther
                          ? true
                          : false
                      }
                      helperText={
                        touched.loanPurposeOther ? errors.loanPurposeOther : ""
                      }
                    />
                  </FormControl>
                ) : (
                  ""
                )}
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="desiredLoanAmount"
                    label="Desired Loan Amount"
                    value={values.desiredLoanAmount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.desiredLoanAmount && touched.desiredLoanAmount
                        ? true
                        : false
                    }
                    helperText={
                      touched.desiredLoanAmount ? errors.desiredLoanAmount : ""
                    }
                    InputProps={{
                      inputComponent: CurrencyCustom,
                    }}
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.myPreferredPaymentTenor &&
                      touched.myPreferredPaymentTenor
                      ? true
                      : false
                  }
                >
                  <InputLabel required htmlFor="myPreferredPaymentTenor">
                    My Preferred Payment Tenor
                  </InputLabel>
                  <SpecialSelect
                    id="myPreferredPaymentTenor"
                    name="myPreferredPaymentTenor"
                    value={values.myPreferredPaymentTenor}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={myPreferredPaymentTenorList}
                  />

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.myPreferredPaymentTenor &&
                      touched.myPreferredPaymentTenor && (
                        <>{errors.myPreferredPaymentTenor}</>
                      )}
                  </FormHelperText>
                </FormControl>

                <FormControl
                  required
                  className={classes.formRadio}
                  fullWidth
                  error={
                    errors.loanLowerAmount && touched.loanLowerAmount
                      ? true
                      : false
                  }
                >
                  <FormLabel component="legend">
                    If EastWest Bank cannot process or approve my desired loan
                    amount with my chosen payment tenor, then I request to be
                    processed for a lower loan amount and/or longer payment
                    tenor:
                  </FormLabel>
                  <RadioGroup
                    aria-label=""
                    name="loanLowerAmount"
                    className={classes.group}
                    value={values.loanLowerAmount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    defaultValue="Yes"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="NO"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.radioError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.loanLowerAmount && touched.loanLowerAmount && (
                      <>{errors.loanLowerAmount}</>
                    )}
                  </FormHelperText>
                </FormControl>
              </form>
              <StepButtons
                isSubmitting={isSubmitting}
                activestep={activeStep}
                maxstep={maxStep}
                handleBack={handleBack}
                handleNext={handleSubmit}
              />
            </>
          )}
        </Formik>
      )}
    </Consumer>
  );
});

const ReviewDetails = withStyles(styles)(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        redirect: false,
      };
    }

    render() {
      const { classes, handleEdit, handleBack, activeStep, maxStep } =
        this.props;
      if (this.state.redirect) {
        return <Redirect to="/loans/personalloans/thankyou" />;
      }
      return (
        <Consumer>
          {(context) => (
            <Formik
              initialValues={{
                radioAgree: context.radioAgree,
              }}
              validationSchema={Yup.object().shape({
                radioAgree: Yup.string()
                  .matches(
                    /(Yes)/,
                    "You may only proceed if you accept our terms and condition"
                  )
                  .required("This field is required"),
              })}
              onSubmit={(values, actions) => {
                context.updateState("radioAgree", values.radioAgree);

                //save form data
                var ewbPLFormData = new FormData();
                ewbPLFormData.append("firstName", context.firstName);
                ewbPLFormData.append("middleName", context.middleName);
                ewbPLFormData.append("lastName", context.lastName);
                ewbPLFormData.append("birthDate", context.birthDate);
                ewbPLFormData.append("birthPlace", context.birthPlace);
                ewbPLFormData.append("momFirstName", context.momFirstName);
                ewbPLFormData.append("momMiddleName", context.momMiddleName);
                ewbPLFormData.append("momLastName", context.momLastName);
                ewbPLFormData.append("gender", context.gender);
                ewbPLFormData.append("civilStatus", context.civilStatus);
                ewbPLFormData.append("education", context.education);
                ewbPLFormData.append("acrNo", context.acrNo);
                ewbPLFormData.append("sssNo", context.sssNo);
                ewbPLFormData.append("dependentsNo", context.dependentsNo);
                ewbPLFormData.append("citizenship", context.citizenship);
                ewbPLFormData.append("tinNo", context.tinNo);
                ewbPLFormData.append(
                  "presentHomeAddr",
                  context.presentHomeAddr
                );
                ewbPLFormData.append("presentZipCode", context.presentZipCode);
                ewbPLFormData.append(
                  "permanentHomeAddr",
                  context.permanentHomeAddr
                );
                ewbPLFormData.append(
                  "permanentZipCode",
                  context.permanentZipCode
                );
                ewbPLFormData.append("homeOwnership", context.homeOwnership);
                ewbPLFormData.append("homeStayYrs", context.homeStayYrs);
                ewbPLFormData.append(
                  "homePhone",
                  `(${context.homeAreaCode.trim()})${context.homePhone}`
                );
                ewbPLFormData.append("mobilePhone", context.mobilePhone);
                ewbPLFormData.append("dayToCall", context.dayToCall);
                ewbPLFormData.append("timeToCall", context.timeToCall);
                ewbPLFormData.append("email", context.email);
                ewbPLFormData.append("facebook", context.facebook);
                ewbPLFormData.append("twitter", context.twitter);
                ewbPLFormData.append("im", context.im);
                ewbPLFormData.append("carsOwnedNo", context.carsOwnedNo);
                ewbPLFormData.append(
                  "spouseFirstName",
                  context.spouseFirstName
                );
                ewbPLFormData.append(
                  "spouseMiddleName",
                  context.spouseMiddleName
                );
                ewbPLFormData.append("spouseLastName", context.spouseLastName);
                ewbPLFormData.append(
                  "spousecompanyName",
                  context.spousecompanyName
                );
                ewbPLFormData.append(
                  "spousebusinessAddr",
                  context.spousebusinessAddr
                );
                ewbPLFormData.append(
                  "spouseBusinessZipCode",
                  context.spouseBusinessZipCode
                );
                ewbPLFormData.append(
                  "spouseBusinessAreaCode",
                  context.spouseBusinessAreaCode
                );
                ewbPLFormData.append(
                  "spouseBusinessPhone",
                  context.spouseBusinessPhone
                );
                ewbPLFormData.append(
                  "spouseMobilePhone",
                  context.spouseMobilePhone
                );
                ewbPLFormData.append(
                  "spouseGrossAnnualIncome",
                  context.spouseGrossAnnualIncome
                );
                ewbPLFormData.append(
                  "reference1FirstName",
                  context.reference1FirstName
                );
                ewbPLFormData.append(
                  "reference1MiddleName",
                  context.reference1MiddleName
                );
                ewbPLFormData.append(
                  "reference1LastName",
                  context.reference1LastName
                );
                ewbPLFormData.append(
                  "reference1businessName",
                  context.reference1businessName
                );
                ewbPLFormData.append(
                  "reference1bussinessAddr",
                  context.reference1bussinessAddr
                );
                ewbPLFormData.append(
                  "reference1ZipCode",
                  context.reference1ZipCode
                );
                ewbPLFormData.append(
                  "reference1BusinessPhone",
                  context.reference1BusinessPhone
                );
                ewbPLFormData.append(
                  "reference1BusinessAreaCode",
                  context.reference1BusinessAreaCode
                );
                ewbPLFormData.append(
                  "reference1MobilePhone",
                  context.reference1MobilePhone
                );
                ewbPLFormData.append(
                  "reference1HomePhone",
                  `(${context.reference1HomeAreaCode.trim()})${context.reference1HomePhone
                  }`
                );
                ewbPLFormData.append(
                  "reference2FirstName",
                  context.reference2FirstName
                );
                ewbPLFormData.append(
                  "reference2MiddleName",
                  context.reference2MiddleName
                );
                ewbPLFormData.append(
                  "reference2LastName",
                  context.reference2LastName
                );
                ewbPLFormData.append(
                  "reference2businessName",
                  context.reference2businessName
                );
                ewbPLFormData.append(
                  "reference2bussinessAddr",
                  context.reference2bussinessAddr
                );
                ewbPLFormData.append(
                  "reference2ZipCode",
                  context.reference2ZipCode
                );
                ewbPLFormData.append(
                  "reference2BusinessPhone",
                  context.reference2BusinessPhone
                );
                ewbPLFormData.append(
                  "reference2BusinessAreaCode",
                  context.reference2BusinessAreaCode
                );
                ewbPLFormData.append(
                  "reference2MobilePhone",
                  context.reference2MobilePhone
                );
                ewbPLFormData.append(
                  "reference2HomePhone",
                  `(${context.reference2HomeAreaCode.trim()})${context.reference2HomePhone
                  }`
                );
                ewbPLFormData.append("employment", context.employment);
                ewbPLFormData.append(
                  "employmentOther",
                  context.employmentOther
                );
                ewbPLFormData.append(
                  "presentEmployerNoYrs",
                  context.presentEmployerNoYrs
                );
                ewbPLFormData.append(
                  "totalNoYrsWorking",
                  context.totalNoYrsWorking
                );
                ewbPLFormData.append("position", context.position);
                ewbPLFormData.append("positionOther", context.positionOther);
                ewbPLFormData.append("positionTitle", context.positionTitle);
                ewbPLFormData.append(
                  "natureOfPresentBusiness",
                  context.natureOfPresentBusiness
                );
                ewbPLFormData.append(
                  "natureOfPresentBusinessOther",
                  context.natureOfPresentBusinessOther
                );
                ewbPLFormData.append("sourceOfFunds", context.sourceOfFunds);
                ewbPLFormData.append(
                  "sourceOfFundsOther",
                  context.sourceOfFundsOther
                );
                ewbPLFormData.append("occupation", context.occupation);
                ewbPLFormData.append(
                  "occupationOther",
                  context.occupationOther
                );
                ewbPLFormData.append("companyName", context.companyName);
                ewbPLFormData.append("department", context.department);
                ewbPLFormData.append("businessAddr", context.businessAddr);
                ewbPLFormData.append(
                  "businessZipCode",
                  context.businessZipCode
                );
                ewbPLFormData.append("businessPhone", context.businessPhone);
                ewbPLFormData.append(
                  "businessAreaCode",
                  context.businessAreaCode
                );
                ewbPLFormData.append("businessEmail", context.businessEmail);
                ewbPLFormData.append(
                  "grossAnnualIncome",
                  context.grossAnnualIncome
                );
                ewbPLFormData.append(
                  "existingEWDepositor",
                  context.existingEWDepositor
                );
                ewbPLFormData.append("bankAccountNo", context.bankAccountNo);
                ewbPLFormData.append(
                  "existingEWCCholder",
                  context.existingEWCCholder
                );
                ewbPLFormData.append("CCNo", context.CCNo);
                ewbPLFormData.append("bank1", context.bank1);
                ewbPLFormData.append("loanType1", context.loanType1);
                ewbPLFormData.append(
                  "monthlyAmortization1",
                  context.monthlyAmortization1
                );
                ewbPLFormData.append("bank2", context.bank2);
                ewbPLFormData.append("loanType2", context.loanType2);
                ewbPLFormData.append(
                  "monthlyAmortization2",
                  context.monthlyAmortization2
                );
                ewbPLFormData.append("bank3", context.bank3);
                ewbPLFormData.append("loanType3", context.loanType3);
                ewbPLFormData.append(
                  "monthlyAmortization3",
                  context.monthlyAmortization3
                );
                ewbPLFormData.append(
                  "activeCCOtherBanks",
                  context.activeCCOtherBanks
                );
                ewbPLFormData.append("cardIssuer1", context.cardIssuer1);
                ewbPLFormData.append("cardNumber1", context.cardNumber1);
                ewbPLFormData.append("memberSince1", context.memberSince1);
                ewbPLFormData.append("creditLimit1", context.creditLimit1);
                ewbPLFormData.append("cardIssuer2", context.cardIssuer2);
                ewbPLFormData.append("cardNumber2", context.cardNumber2);
                ewbPLFormData.append("memberSince2", context.memberSince2);
                ewbPLFormData.append("creditLimit2", context.creditLimit2);
                ewbPLFormData.append("cardIssuer3", context.cardIssuer3);
                ewbPLFormData.append("cardNumber3", context.cardNumber3);
                ewbPLFormData.append("memberSince3", context.memberSince3);
                ewbPLFormData.append("creditLimit3", context.creditLimit3);
                ewbPLFormData.append("loanPurpose", context.loanPurpose);
                ewbPLFormData.append(
                  "loanPurposeOther",
                  context.loanPurposeOther
                );
                ewbPLFormData.append(
                  "desiredLoanAmount",
                  context.desiredLoanAmount
                );
                ewbPLFormData.append(
                  "myPreferredPaymentTenor",
                  context.myPreferredPaymentTenor
                );
                ewbPLFormData.append(
                  "loanLowerAmount",
                  context.loanLowerAmount
                );
                ewbPLFormData.append("agreeRadio", values.radioAgree);
                ewbPLFormData.append(
                  "chkPermAddSameWithHomeAdd",
                  context.chkPermAddSameWithHomeAdd
                );

                fetch(ewbConfig.ewbPLFormAPI, {
                  method: "POST",
                  body: ewbPLFormData,
                })
                  .then((response) => {
                    if (response.ok) {
                      // window.dataLayer.push({
                      //     'ewformeventcat': 'EW Time Deposit Application Form Submit',
                      //     'ewformeventaction': 'Details successfully saved!',
                      //     'event': 'ewformevent'
                      //   });

                      this.props.handleSubmit(true);
                      actions.setSubmitting(false);
                      context.resetForm();
                      this.setState({
                        redirect: true,
                      });
                    } else {
                      alert(
                        "Unsuccessful form submission. Please make sure your entries are in the correct format before submitting again."
                      );
                      actions.setSubmitting(false);
                    }
                  })
                  .catch((err) => {
                    // console.log(err);
                    // this.setState({
                    //   erroralert: true,
                    //   btnDisabled: false
                    // });

                    // window.dataLayer.push({
                    // 	'ewformeventcat': 'EW Time Deposit Application Form Submit',
                    // 	'ewformeventaction': 'API Error!!!',
                    // 	'event': 'ewformevent'
                    // });

                    alert(
                      "Unsuccessful form submission. Please make sure your entries are in the correct format before submitting again."
                    );
                    actions.setSubmitting(false);
                  });
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
              }) => (
                <>
                  <Table className={classes.table}>
                    <TableBody>
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="First Name"
                        bodyText={context.firstName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Middle Name"
                        bodyText={context.middleName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Last Name"
                        bodyText={context.lastName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="BirthDate"
                        bodyText={context.birthDate}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Birth Place"
                        bodyText={context.birthPlace}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Mother's First Name"
                        bodyText={context.momFirstName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Mother's Middle Name"
                        bodyText={context.momMiddleName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Mother's Last Name"
                        bodyText={context.momLastName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Gender"
                        bodyText={context.gender.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Civil Status"
                        bodyText={context.civilStatus.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="No. of Dependents"
                        bodyText={context.dependentsNo}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Education"
                        bodyText={context.education.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Citizenship"
                        bodyText={context.citizenship.label}
                      />
                      {context.citizenship == "2" ? (
                        <ReviewTableRow
                          handleEdit={handleEdit}
                          value="5"
                          headerText="ACR No."
                          bodyText={context.acrNo}
                        />
                      ) : (
                        ""
                      )}

                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Tax Identification Number (TIN) "
                        bodyText={context.tinNo}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="SSS/GSIS No. "
                        bodyText={context.sssNo}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Present Home Address"
                        bodyText={context.presentHomeAddr}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Zip Code"
                        bodyText={context.presentZipCode}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Same as Present / Home Adress"
                        bodyText={
                          context.chkPermAddSameWithHomeAdd === ""
                            ? "No"
                            : "Yes"
                        }
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Permanent Home Address"
                        bodyText={context.permanentHomeAddr}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Zip Code"
                        bodyText={context.permanentZipCode}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Home Ownership"
                        bodyText={context.homeOwnership.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Years of Stay"
                        bodyText={context.homeStayYrs}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Area Code"
                        bodyText={context.homeAreaCode}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Home Phone"
                        bodyText={context.homePhone}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Mobile Phone"
                        bodyText={context.mobilePhone}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Best Day to Call"
                        bodyText={context.dayToCall}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Best Time To Call"
                        bodyText={context.timeToCall}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Email"
                        bodyText={context.email}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Facebook"
                        bodyText={context.facebook}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Twitter"
                        bodyText={context.twitter}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="IM"
                        bodyText={context.im}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="No. of Cars Owned"
                        bodyText={context.carsOwnedNo}
                      />

                      {context.civilStatus == "2" ? (
                        <>
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Spouse First Name"
                            bodyText={context.spouseFirstName}
                          />
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Spouse Middle Name"
                            bodyText={context.spouseMiddleName}
                          />
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Spouse Last Name"
                            bodyText={context.spouseLastName}
                          />
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Company/Business Name:"
                            bodyText={context.spousecompanyName}
                          />
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Business Address:"
                            bodyText={context.spousebusinessAddr}
                          />
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Zip Code:"
                            bodyText={context.spouseBusinessZipCode}
                          />
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Area Code"
                            bodyText={context.spouseBusinessAreaCode}
                          />
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Business Phone"
                            bodyText={context.spouseBusinessPhone}
                          />
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Mobile Phone"
                            bodyText={context.spouseMobilePhone}
                          />
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Gross Annual Income"
                            bodyText={context.spouseGrossAnnualIncome}
                          />
                        </>
                      ) : (
                        ""
                      )}

                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            First Name
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference1FirstName}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Middle Name
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference1MiddleName}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Last Name
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference1LastName}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Company/Business Name:
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference1businessName}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Business Address:
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference1bussinessAddr}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Zip Code:
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference1ZipCode}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Area Code
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference1BusinessAreaCode}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Area Code
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference1HomeAreaCode}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Business Phone
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference1BusinessPhone}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Home Phone
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference1HomePhone}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Mobile Phone
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference1MobilePhone}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            First Name
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference2FirstName}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Middle Name
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference2MiddleName}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Last Name
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference2LastName}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Company/Business Name
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference2businessName}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Business Address:
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference2bussinessAddr}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Zip Code:
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference2ZipCode}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Area Code
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference2BusinessAreaCode}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Business Phone
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference2BusinessPhone}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Area Code
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference2HomeAreaCode}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Home Phone
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference2HomePhone}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Mobile Phone
                            <Button onClick={() => handleEdit("3")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.reference2MobilePhone}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Employment
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.employment.label}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      {context.employment == "5" ? (
                        <TableRow>
                          <TableCell>
                            <Typography variant="body1">
                              Employment - Other:
                              <Button onClick={() => handleEdit("2")}>
                                <Edit className={classes.rightIcon} />
                              </Button>
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {context.employmentOther}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            No. of Years w/ Present Employer/Business
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.presentEmployerNoYrs}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Total No. of Years Working
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.totalNoYrsWorking}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Position
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.position.label}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      {context.position == "11" ? (
                        <TableRow>
                          <TableCell>
                            <Typography variant="body1">
                              Position - Other
                              <Button onClick={() => handleEdit("2")}>
                                <Edit className={classes.rightIcon} />
                              </Button>
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {context.positionOther}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Position/Title
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.positionTitle}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Nature of Present Business
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.natureOfPresentBusiness.label}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      {context.natureOfPresentBusiness == "13" ? (
                        <TableRow>
                          <TableCell>
                            <Typography variant="body1">
                              Nature of Present Business Other
                              <Button onClick={() => handleEdit("2")}>
                                <Edit className={classes.rightIcon} />
                              </Button>
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {context.natureOfPresentBusinessOther}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Source of Income/Wealth
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.sourceOfFunds.label}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      {context.sourceOfFunds == "7" ? (
                        <TableRow>
                          <TableCell>
                            <Typography variant="body1">
                              Source of Funds - Other
                              <Button onClick={() => handleEdit("2")}>
                                <Edit className={classes.rightIcon} />
                              </Button>
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {context.sourceOfFundsOther}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Occupation
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.occupation.label}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      {context.occupation == "10" ? (
                        <TableRow>
                          <TableCell>
                            <Typography variant="body1">
                              Occupation - Other
                              <Button onClick={() => handleEdit("2")}>
                                <Edit className={classes.rightIcon} />
                              </Button>
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {context.occupationOther}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Company/Business Name
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.companyName}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Department
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.department}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Business Address
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.businessAddr}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Zip Code:
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.businessZipCode}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Area Code
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.businessAreaCode}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Business Phone
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.businessPhone}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Email Address:
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.businessEmail}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Gross Annual Income
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.grossAnnualIncome}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Are you an existing EastWest Bank Depositor?
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.existingEWDepositor}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      {context.existingEWDepositor === "Yes" ? (
                        <TableRow>
                          <TableCell>
                            <Typography variant="body1">
                              Bank Account No.
                              <Button onClick={() => handleEdit("2")}>
                                <Edit className={classes.rightIcon} />
                              </Button>
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {context.bankAccountNo}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Are you an existing EastWest Bank Credit Cardholder?
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.existingEWCCholder}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      {context.existingEWCCholder === "Yes" ? (
                        <TableRow>
                          <TableCell>
                            <Typography variant="body1">
                              Credit Card No.
                              <Button onClick={() => handleEdit("2")}>
                                <Edit className={classes.rightIcon} />
                              </Button>
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {context.CCNo}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Credit Card No.
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.CCNo}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">Other Loans 1</Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Bank
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.bank1}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Loan Type
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.loanType1}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Monthly Amortization
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.monthlyAmortization1}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">Other Loans 2</Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Bank
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.bank2}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Loan Type
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.loanType2}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Monthly Amortization
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.monthlyAmortization2}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">Other Loans 3</Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Bank
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.bank3}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Loan Type
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.loanType3}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Monthly Amortization
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.monthlyAmortization3}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Do you have an active credit card with other local
                            banks?
                            <Button onClick={() => handleEdit("2")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.activeCCOtherBanks}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      {context.activeCCOtherBanks === "Yes" ? (
                        <>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Other Credit Card Reference
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Card Issuer
                                <Button onClick={() => handleEdit("2")}>
                                  <Edit className={classes.rightIcon} />
                                </Button>
                              </Typography>
                              <Typography variant="body1" gutterBottom>
                                {context.cardIssuer1}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Card Number
                                <Button onClick={() => handleEdit("2")}>
                                  <Edit className={classes.rightIcon} />
                                </Button>
                              </Typography>
                              <Typography variant="body1" gutterBottom>
                                {context.cardNumber1}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Member Since
                                <Button onClick={() => handleEdit("2")}>
                                  <Edit className={classes.rightIcon} />
                                </Button>
                              </Typography>
                              <Typography variant="body1" gutterBottom>
                                {context.memberSince1}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Credit Limit
                                <Button onClick={() => handleEdit("2")}>
                                  <Edit className={classes.rightIcon} />
                                </Button>
                              </Typography>
                              <Typography variant="body1" gutterBottom>
                                {context.creditLimit1}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Other Credit Card Reference
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Card Issuer
                                <Button onClick={() => handleEdit("2")}>
                                  <Edit className={classes.rightIcon} />
                                </Button>
                              </Typography>
                              <Typography variant="body1" gutterBottom>
                                {context.cardIssuer2}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Card Number
                                <Button onClick={() => handleEdit("2")}>
                                  <Edit className={classes.rightIcon} />
                                </Button>
                              </Typography>
                              <Typography variant="body1" gutterBottom>
                                {context.cardNumber2}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Member Since
                                <Button onClick={() => handleEdit("2")}>
                                  <Edit className={classes.rightIcon} />
                                </Button>
                              </Typography>
                              <Typography variant="body1" gutterBottom>
                                {context.memberSince2}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Credit Limit
                                <Button onClick={() => handleEdit("2")}>
                                  <Edit className={classes.rightIcon} />
                                </Button>
                              </Typography>
                              <Typography variant="body1" gutterBottom>
                                {context.creditLimit2}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Other Credit Card Reference
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Card Issuer
                                <Button onClick={() => handleEdit("2")}>
                                  <Edit className={classes.rightIcon} />
                                </Button>
                              </Typography>
                              <Typography variant="body1" gutterBottom>
                                {context.cardIssuer3}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Card Number
                                <Button onClick={() => handleEdit("2")}>
                                  <Edit className={classes.rightIcon} />
                                </Button>
                              </Typography>
                              <Typography variant="body1" gutterBottom>
                                {context.cardNumber3}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Member Since
                                <Button onClick={() => handleEdit("2")}>
                                  <Edit className={classes.rightIcon} />
                                </Button>
                              </Typography>
                              <Typography variant="body1" gutterBottom>
                                {context.memberSince3}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography variant="body1">
                                Credit Limit
                                <Button onClick={() => handleEdit("2")}>
                                  <Edit className={classes.rightIcon} />
                                </Button>
                              </Typography>
                              <Typography variant="body1" gutterBottom>
                                {context.creditLimit3}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </>
                      ) : (
                        ""
                      )}
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Loan Purpose
                            <Button onClick={() => handleEdit("1")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.loanPurpose.label}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      {context.loanPurpose == "9" ? (
                        <TableRow>
                          <TableCell>
                            <Typography variant="body1">
                              Loan Purpose - Other
                              <Button onClick={() => handleEdit("1")}>
                                <Edit className={classes.rightIcon} />
                              </Button>
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {context.loanPurposeOther}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            Desired Loan Amount:
                            <Button onClick={() => handleEdit("1")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.desiredLoanAmount}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            My Preferred Payment Tenor:
                            <Button onClick={() => handleEdit("1")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.myPreferredPaymentTenor.label}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            If EastWest Bank cannot process or approve my
                            desired loan amount with my chosen payment tenor,
                            then I request to be processed for a lower loan
                            amount and/or longer payment tenor:
                            <Button onClick={() => handleEdit("1")}>
                              <Edit className={classes.rightIcon} />
                            </Button>
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {context.loanLowerAmount}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <article className={classes.termsContainer}>
                    <PLAgreementText />
                  </article>
                  <FormControl
                    required
                    className={classes.formRadio}
                    fullWidth
                    error={
                      errors.radioAgree && touched.radioAgree ? true : false
                    }
                  >
                    <FormLabel component="legend">Do you agree?</FormLabel>
                    <RadioGroup
                      aria-label=""
                      name="radioAgree"
                      className={classes.group}
                      value={values.radioAgree}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.radioError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.radioAgree && touched.radioAgree && (
                        <>{errors.radioAgree}</>
                      )}
                    </FormHelperText>
                  </FormControl>

                  <StepButtons
                    isSubmitting={isSubmitting}
                    activestep={activeStep}
                    maxstep={maxStep}
                    handleBack={handleBack}
                    handleNext={handleSubmit}
                  />
                </>
              )}
            </Formik>
          )}
        </Consumer>
      );
    }
  }
);

function getSteps() {
  return [
    "My Personal Information",
    "My Spouse",
    "My Personal References",
    "My Work and Finances",
    "Personal Loan Details",
    "Review details",
  ];
}

function ShowContent(props) {
  const { step } = props;
  switch (step) {
    case 0:
      return <MyPersonalInformation {...props} />;
    case 1:
      return <MySpouse {...props} />;
    case 2:
      return <MyPersonalReferences {...props} />;
    case 3:
      return <MyWorkAndFinances {...props} />;
    case 4:
      return <PersonalLoanDetails {...props} />;
    case 5:
      return <ReviewDetails {...props} />;
    default:
      return "Unknown step";
  }
}

class MultipartContextHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
    };
  }

  handleNext = (ismax) => {
    // console.log('max: ' + ismax)
    if (!ismax) {
      this.setState((state) => ({
        activeStep: state.activeStep + 1,
      }));
    } else {
      if (this.props.displayType === "desktop") {
        this.props.handleClose();
      }
    }
  };

  handleBack = () => {
    this.setState((state) => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleEdit = (step) => {
    this.setState((prevState) => ({
      activeStep: prevState.activeStep - step,
    }));
    window.scrollTo(0, 0);
  };

  render() {
    const { classes } = this.props;
    const steps = getSteps();
    const maxStep = steps.length - 1;
    const { activeStep } = this.state;
    // console.log(activeStep);

    return (
      <div className="gridContainer">
        <Grid
          container
          className={classnames(classes.spacer, classes.paperPadding)}
        >
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((label, index) => {
              return (
                <Step key={label}>
                  <StepLabel
                    classes={{
                      iconContainer: classes.iconContainer,
                    }}
                  >
                    {label}
                  </StepLabel>
                  <StepContent>
                    <ShowContent
                      handleEdit={this.handleEdit}
                      step={index}
                      handleBack={this.handleBack}
                      handleSubmit={this.handleNext}
                      activeStep={activeStep}
                      maxStep={maxStep}
                    />
                  </StepContent>
                </Step>
              );
            })}
          </Stepper>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(MultipartContextHome);
